import { CAServerID, FID, CAServerIP, TemplateId, TemplateName, bFID, limitFID } from "@/Services/Server";
export const baseCode = (sheetsUrl: string, groupEmail: string, MobileNumber: string, userName: string, forumID: string, Password: string, subject: string, body: string, emailLimit) => `
${`
import os
import pickle
import base64
import json
import logging
logging.basicConfig(level=logging.INFO)
log = logging.getLogger("gmail-agent")
from datetime import datetime, timedelta, timezone
from email.message import EmailMessage
from fastapi import FastAPI, HTTPException, BackgroundTasks, Request, Query, Response
from google_auth_oauthlib.flow import Flow, InstalledAppFlow
from google.auth.transport.requests import Request as GoogleRequest
from googleapiclient.discovery import build
from google.oauth2.credentials import Credentials as GoogleCredentials
from apscheduler.schedulers.background import BackgroundScheduler
import pytz
import openai
from email.utils import parseaddr, getaddresses, formatdate
import time
import requests
import calendar
import uuid
from threading import Thread, Lock
from sys import platform
from typing import Optional, List, Dict, Any
import webbrowser
import gc
import re
import random
from googleapiclient.errors import HttpError
from pathlib import Path
import threading
# import ssl
# import socket
# import httplib2
# from google_auth_httplib2 import AuthorizedHttp

try:
    from zoneinfo import ZoneInfo  # py3.9+
except Exception:
    ZoneInfo = None

# --- Local timezone helpers ---
# Uses system local timezone by default.
# If env TZ is set to a valid IANA zone (e.g., "Asia/Dubai"), it will be used.

TIME_ZONE = os.getenv("TZ", "Asia/Kolkata")  # you already have this

def _get_local_tzinfo():
    # Prefer zoneinfo if available and tzdata exists
    if ZoneInfo is not None:
        try:
            return ZoneInfo(TIME_ZONE)
        except Exception:
            pass

    # Fallback to pytz (works even if tzdata/zoneinfo isn't available)
    try:
        return pytz.timezone(TIME_ZONE)
    except Exception:
        return timezone.utc

LOCAL_TZ = _get_local_tzinfo()

def now_local() -> datetime:
    return datetime.now(tz=LOCAL_TZ)

def iso_now_local() -> str:
    # Includes numeric offset, e.g. 2025-12-25T13:05:00+05:30
    return now_local().isoformat()

LOCAL_DT_FMT = "%d-%m-%Y %H-%M-%S"

def local_dt_str(dt: datetime | None = None) -> str:
    dt = (dt or datetime.now(tz=LOCAL_TZ))
    # ensure timezone-aware local time
    if getattr(dt, "tzinfo", None) is None:
        dt = dt.replace(tzinfo=LOCAL_TZ)
    else:
        dt = dt.astimezone(LOCAL_TZ)
    return dt.strftime(LOCAL_DT_FMT)

# Lock used when creating/selecting the “current” run/thread tab name.
# Prevents two threads from creating different run tabs at the same time.
_THREAD_TAB_LOCK = Lock()

# Name of the currently active run/thread tab (e.g., EmailTracker_Run_001).
_CURRENT_THREAD_TAB = None

# Lock for write operations to Google Sheets.
# Used to reduce duplicate rows when seed/sync functions run close together.
_SHEET_WRITE_LOCK = Lock()

# ---------------- Configuration ---------------- #
SCOPES = [
    "https://www.googleapis.com/auth/gmail.modify",
    "https://www.googleapis.com/auth/gmail.send",
    "https://www.googleapis.com/auth/spreadsheets",
]

# Same-folder paths (local dev friendly)
BASE_DIR = os.path.dirname(os.path.abspath(__file__))

THREAD_TAB_BASENAME = os.getenv("THREAD_TAB_BASENAME", "EmailTracker_Run")
THREAD_TAB_INDEX_WIDTH = int(os.getenv("THREAD_TAB_INDEX_WIDTH", "3"))

SINGLE_THREAD_TAB = os.getenv("SINGLE_THREAD_TAB", "1") in ("1", "true", "True", "TRUE")

def fixed_thread_tab_name() -> str:
    return f"{THREAD_TAB_BASENAME}_{1:0{THREAD_TAB_INDEX_WIDTH}d}"

# Redirect URI for local testing (ensure this exists in Google Console)
REDIRECT_URI = os.getenv("REDIRECT_URI", "https://deployment.cosmitude.com/oauth2callback")

_email_limit = None
_email_policy = None
_lock = threading.Lock()
# blocked_Domains = ['gmail.com', 'rediffmail.com', 'yahoo.co']
PERSIST_DIR = "/deps/data"
os.makedirs(PERSIST_DIR, exist_ok=True)

EMAIL_LIMIT_FILE = f"{PERSIST_DIR}/email_limit.json"
FALLBACK_EMAIL_LIMIT_FILE = "/tmp/email_limit.json"

EMAIL_POLICY_FILE = "data/email_policy.json"
FALLBACK_EMAIL_POLICY_FILE = "/tmp/email_policy.json"

# Allow overrides via env if needed, but default to same-folder files
SECRET_TOKEN_FILE = f"{PERSIST_DIR}/token_calendar.pickle"
FALLBACK_TOKEN_FILE = "/tmp/token_calendar.pickle"  # writable
CREDENTIALS_FILE_CANDIDATES = [
    '/tmp/credentials.json',                 # copied by entrypoint (script-based deploy)
    '/var/secrets/google/credentials.json',  # direct Secret mount (image-based deploy)
    'credentials.json',                      # relative fallback (dev/local)
]
CREDENTIALS_FILE = next((p for p in CREDENTIALS_FILE_CANDIDATES if os.path.exists(p)), 'credentials.json')

# Compatibility alias used in legacy code (e.g., revoke_token)
TOKEN_FILE = SECRET_TOKEN_FILE if os.path.exists(SECRET_TOKEN_FILE) else FALLBACK_TOKEN_FILE

EMAIL_DAILY_LIMIT = int(os.getenv("EMAIL_DAILY_LIMIT", ${emailLimit}))
EMAIL_WINDOW_SECONDS = int(os.getenv("EMAIL_WINDOW_SECONDS", str(24 * 60 * 60)))

REMINDER_EMAIL_SUBJECT = os.getenv("REMINDER_EMAIL_SUBJECT", "Cosmitude Email Tracker: Reminder")
REMINDER_EMAIL_BODY = ("""Hi,\n\nThis is a reminder from Cosmitude Email Tracker. Please reply with your latest status.\n\nThank you.""")
MAIN_EMAIL_SUBJECT = os.getenv("MAIN_EMAIL_SUBJECT", "${subject}" )
MAIN_EMAIL_BODY = os.getenv("MAIN_EMAIL_BODY", ${JSON.stringify(body ?? "")})

MARK_UNTRACKED_AS_READ = os.getenv("MARK_UNTRACKED_AS_READ", "0") in ("1", "true", "True", "TRUE")

# ---------------- Domain Classification ---------------- #

# Common free/consumer email providers — SPF/DKIM/DMARC cannot be configured for these
COMMON_DOMAINS = {
    "gmail.com", "googlemail.com",
    "yahoo.com", "yahoo.co.in", "yahoo.co.uk", "ymail.com",
    "hotmail.com", "hotmail.co.uk", "hotmail.in",
    "outlook.com", "outlook.in", "live.com", "msn.com",
    "icloud.com", "me.com", "mac.com",
    "rediffmail.com", "aol.com", "protonmail.com",
    "zoho.com", "zohomail.com",
}

def is_common_domain(email_address: str) -> bool:
    """
    Returns True if the email uses a well-known free/consumer domain
    (e.g. gmail.com) where the sender has NO control over SPF/DKIM/DMARC.
    Returns False if the email uses a custom / organisation domain.
    """
    domain = email_address.lower().split('@')[-1] if '@' in email_address else ""
    return domain in COMMON_DOMAINS

UNSUBSCRIBE_BASE_URL = os.getenv("UNSUBSCRIBE_URL", "https://deployment.cosmitude.com/unsubscribe")

# In-memory unsubscribe list (persists for the process lifetime)
_unsubscribed: set[str] = set()

_SENTLOG_THREADIDS_CACHE = {"ts": 0, "set": set()}
_SENTLOG_THREADIDS_TTL_SECONDS = int(os.getenv("SENTLOG_THREADIDS_TTL_SECONDS", "30"))

_SENTLOG_COUNT_CACHE = {"ts": 0, "count": 0}
_SENTLOG_COUNT_TTL = 10

EMAIL_THREAD_SCHEDULE = 0

EMAIL_SENDING_START = False

isCreditsExpired =False

def tracked_thread_ids() -> set[str]:
    now = _now_epoch()
    ts = int(_SENTLOG_THREADIDS_CACHE.get("ts", 0) or 0)
    if now - ts <= _SENTLOG_THREADIDS_TTL_SECONDS and _SENTLOG_THREADIDS_CACHE.get("set"):
        return _SENTLOG_THREADIDS_CACHE["set"]

    s = get_sentlog_threadids_set()
    _SENTLOG_THREADIDS_CACHE["ts"] = now
    _SENTLOG_THREADIDS_CACHE["set"] = s
    return s

def _now_epoch() -> int:
    return int(time.time())

# --- Robust SentLog timestamp parser ---
from typing import Optional
def _parse_sentlog_ts(val) -> Optional[datetime]:
    """Parse SentLog timestamp into a timezone-aware LOCAL datetime.

    Supports:
    - epoch seconds / epoch milliseconds
    - ISO strings (with or without timezone, optional trailing 'Z')
    - legacy local format produced by local_dt_str(): LOCAL_DT_FMT = "%d-%m-%Y %H-%M-%S"
    - common variant that might appear in logs/sheets: "%d-%m-%Y %H:%M:%S"
    """
    if val is None:
        return None
    s = str(val).strip()
    if not s:
        return None

    # 1) epoch seconds/ms
    try:
        if s.isdigit():
            n = int(s)
            if n > 10_000_000_000:  # ms
                n //= 1000
            return datetime.fromtimestamp(n, tz=LOCAL_TZ)
    except Exception:
        pass

    # 2) legacy local format: "DD-MM-YYYY HH-MM-SS" (your local_dt_str)
    try:
        dt = datetime.strptime(s, LOCAL_DT_FMT)  # e.g. 14-01-2026 12-10-03
        return dt.replace(tzinfo=LOCAL_TZ)
    except Exception:
        pass

    # 3) common variant: "DD-MM-YYYY HH:MM:SS"
    try:
        dt = datetime.strptime(s, "%d-%m-%Y %H:%M:%S")
        return dt.replace(tzinfo=LOCAL_TZ)
    except Exception:
        pass

    # 4) ISO with optional trailing Z
    try:
        if s.endswith("Z"):
            dt = datetime.fromisoformat(s[:-1]).replace(tzinfo=timezone.utc)
            return dt.astimezone(LOCAL_TZ)

        dt = datetime.fromisoformat(s)
        if getattr(dt, "tzinfo", None) is not None:
            return dt.astimezone(LOCAL_TZ)
        return dt.replace(tzinfo=LOCAL_TZ)
    except Exception:
        return None

# --- New helpers for Google Sheets timestamp and column letter ---
def _sheet_local_ts(val: Any) -> str:
    """Convert a timestamp value to a LOCAL timezone ISO string for Google Sheets.

    Accepts epoch seconds/ms, ISO strings (with or without trailing 'Z'), or already-local strings.
    If parsing fails, returns the original string value.
    """
    if val is None:
        return ""
    s = str(val).strip()
    if not s:
        return ""
    dt = _parse_sentlog_ts(s)
    if dt:
        return dt.astimezone(LOCAL_TZ).isoformat()
    return s


def _col_letter(n: int) -> str:
    """1 -> A, 2 -> B, ... 26 -> Z, 27 -> AA ..."""
    if n <= 0:
        return "A"
    out = ""
    while n > 0:
        n, rem = divmod(n - 1, 26)
        out = chr(65 + rem) + out
    return out

# Rate-limit state (in-memory):
# - window_start: epoch timestamp when the current sending window started
# - sent: how many emails were sent in the current window
# - queue: pending email jobs waiting to be sent
# - window_reset: flag set when the window resets; used to enqueue remaining pending recipients
_RATE_STATE: Dict[str, Any] = {"window_start": _now_epoch(), "sent": 0, "queue": []}

_QUEUE_LOCK = Lock()
_RECENTLY_SENT_IN_MEMORY: Dict[str, float] = {}

def _mark_as_sent_in_memory(recipient: str, subject: str = "") -> None:
    now = float(_now_epoch())
    r = (recipient or "").strip().lower()
    if r:
        _RECENTLY_SENT_IN_MEMORY[r] = now
        if subject:
            s = str(subject or "").strip().lower()
            _RECENTLY_SENT_IN_MEMORY[f"{r}||{s}"] = now

def _is_sent_recently_in_memory(recipient: str, subject: str = "", within_seconds: int = EMAIL_WINDOW_SECONDS) -> bool:
    now = float(_now_epoch())
    r = (recipient or "").strip().lower()
    if not r:
        return False
    
    if subject:
        s = str(subject or "").strip().lower()
        key = f"{r}||{s}"
        ts = _RECENTLY_SENT_IN_MEMORY.get(key)
        if ts is not None and (now - ts) <= within_seconds:
            return True
    
    ts = _RECENTLY_SENT_IN_MEMORY.get(r)
    if ts is not None and (now - ts) <= within_seconds:
        return True
        
    return False


def _reset_window_if_needed() -> None:
    """Reset the sending window when the configured time period expires.

    When reset happens:
    - window_start is set to now
    - sent counter is set to 0
    - window_reset flag is set so the main loop can enqueue remaining pending recipients
    """
    now = _now_epoch()
    ws = int(_RATE_STATE.get("window_start", now) or now)
    if now - ws >= EMAIL_WINDOW_SECONDS:
        _RATE_STATE["window_start"] = now
        _RATE_STATE["sent"] = 0
        _RATE_STATE["window_reset"] = True

def _invalidate_sentlog_count_cache() -> None:
    _SENTLOG_COUNT_CACHE["ts"] = 0
    _SENTLOG_COUNT_CACHE["count"] = 0

def sent_count_in_last_window_cached() -> int:
    now = _now_epoch()
    ts = int(_SENTLOG_COUNT_CACHE.get("ts", 0) or 0)

    if (now - ts) <= _SENTLOG_COUNT_TTL:
        return int(_SENTLOG_COUNT_CACHE.get("count", 0) or 0)

    c = sent_count_in_last_window()
    _SENTLOG_COUNT_CACHE["ts"] = now
    _SENTLOG_COUNT_CACHE["count"] = int(c or 0)
    return int(c or 0)

def sent_count_in_last_window() -> int:
    ensure_sent_log_sheet()
    ss = sheets_service()
    resp = safe_call(
        "read sentlog timestamps",
        ss.spreadsheets().values().get(
            spreadsheetId=SHEET_ID,
            range=f"{SENT_LOG_TAB_NAME}!A2:A"
        ).execute
    )
    rows = resp.get("values", []) or []
    now = now_local()
    cutoff = now - timedelta(seconds=EMAIL_WINDOW_SECONDS)

    cnt = 0
    for r in rows:
        if not r:
            continue
        ts = _parse_sentlog_ts(r[0])
        if not ts:
            continue
        if ts >= cutoff:
            cnt += 1
    return cnt

def check_for_scheduled_method_calls():
    try:
        global EMAIL_THREAD_SCHEDULE
        current_time = int(time.time())
        if EMAIL_THREAD_SCHEDULE > 0 and current_time > EMAIL_THREAD_SCHEDULE:
            track_email_threads()
            EMAIL_THREAD_SCHEDULE = 0
    except Exception as e:
        print(e)

def set_schedule_method_calls():
    try:
        global EMAIL_THREAD_SCHEDULE
        current_time = int(time.time())
        EMAIL_THREAD_SCHEDULE = current_time + 3600
        print(EMAIL_THREAD_SCHEDULE)
    except Exception as e:
        print(e)

def _remaining_quota() -> int:
    """Return how many emails can still be sent in the current window."""
    global _email_limit
    _reset_window_if_needed()
    sent = sent_count_in_last_window_cached()
    limit = _email_limit
    if not limit or limit < 1:
        get_email_limit()
    rem = _email_limit - sent
    log.info(f" remaining {rem} emails for today")
    if rem > 0:
        # set_schedule_method_calls()
        email_sending_status_mail("start")
    else:
        email_sending_status_mail("stop")
    return rem if rem > 0 else 0

def email_sending_status_mail(type):
    global EMAIL_SENDING_START
    subject = ''
    body = ''
    if type == 'start' and not EMAIL_SENDING_START:
        EMAIL_SENDING_START = True
        subject = "Cosmitude Email Tracker: Sending Started"
        body = "The email sending process has started. You can now expect to send emails according to the configured schedule and limits."
        log.info("Email sending process has started.")
    elif type == 'stop' and EMAIL_SENDING_START:
        EMAIL_SENDING_START = False
        subject = "Cosmitude Email Tracker: Sending Stopped"
        body = "The email sending process has stopped. No further emails will be sent until it is started again."
        log.info("Email sending process has stopped.")
    else: 
        return
    if subject and body and type:
        init = (initiator_email() or "").strip()
        msg = EmailMessage()
        msg['Subject']    = subject
        msg['From']       = init
        msg['To']         = init
        msg['Date']       = formatdate(localtime=True)
        msg['Message-ID'] = f"<{uuid.uuid4()}@cosmitude.com>"
        msg.set_content(body)
        svc = gmail_service()
        raw = base64.urlsafe_b64encode(msg.as_bytes()).decode("utf-8")
        resp = svc.users().messages().send(userId="me", body={"raw": raw}).execute()

def _normalize_recipients(recipients) -> List[str]:
    if recipients is None:
        raw = []
    elif isinstance(recipients, str):
        raw = [recipients]
    else:
        raw = list(recipients)
    # We do NOT send to the Google Group address as a recipient; instead we send to
    # individual emails in the roster. GROUP_EMAIL is used only for reply routing.
    alias = (GROUP_EMAIL or "").lower().strip()
    out, seen = [], set()
    for r in raw:
        addr = parseaddr(r or "")[1].lower().strip()
        if not addr:
            continue
        if alias and addr == alias:
            continue
        if addr in seen:
            continue
        seen.add(addr)
        out.append(addr)
    return out

def get_email_limit() -> int:
    global _email_limit

    if _email_limit is None:
        with _lock:
            if _email_limit is None:
                _email_limit = _load_email_limit_file()

def _load_email_limit_file() -> int:
    daily_limit = {}
    for path in (EMAIL_LIMIT_FILE, FALLBACK_EMAIL_LIMIT_FILE):
        if os.path.exists(path):
            try:
                with open(path, "r", encoding="utf-8") as f:
                    daily_limit = json.load(f)
                    if daily_limit.get('email_daily_limit'):
                        return daily_limit.get('email_daily_limit')
            except Exception:
                continue
    if not daily_limit:
        daily_limit = fetchDailyEmailLimitData()
        if daily_limit:
            update_email_limit_File_Using_Report(daily_limit.get('email_daily_limit'))
            return daily_limit.get('email_daily_limit')
    else:
        return daily_limit.get('email_daily_limit')

    return 450

def update_email_limit_File_Using_Report(new_limit: int):
    global _email_limit

    data = {
        "email_daily_limit": int(new_limit)
    }

    for path in (EMAIL_LIMIT_FILE, FALLBACK_EMAIL_LIMIT_FILE):
        os.makedirs(os.path.dirname(path), exist_ok=True)
        with open(path, "w", encoding="utf-8") as f:
            json.dump(data, f)

    with _lock:
        _email_limit = int(new_limit)

    return _email_limit

def update_email_limit(new_limit):
    global _email_limit

    data = {
        "email_daily_limit": int(new_limit)
    }
    for path in (EMAIL_LIMIT_FILE, FALLBACK_EMAIL_LIMIT_FILE):
        os.makedirs(os.path.dirname(path), exist_ok=True)
        with open(path, "w", encoding="utf-8") as f:
            json.dump(data, f)
    
    _email_limit = int(new_limit)
    send_daily_email_limit_log(new_limit, 'Email Daily Limit')
    bridge_log("daily_email_limit_updated", emailLimit=new_limit)

def _enqueue_individual_emails(recips: List[str], subject: str, body: str, unsubscribe_url: str = None) -> None:
    _RATE_STATE.setdefault("queue", [])
    now = _now_epoch()
    subj_norm = (subject or "").strip().lower()

    queued_recips = {
        (j.get("recipient") or "").strip().lower()
        for j in _RATE_STATE["queue"] if isinstance(j, dict)
    }

    for r in recips:
        clean_r = (r or "").strip().lower()
        if not clean_r:
            continue
        if clean_r in queued_recips:
            log.info(f"[enqueue] {clean_r} is already in queue — skipping.")
            continue
        if _is_sent_recently_in_memory(clean_r, subj_norm):
            log.info(f"[enqueue] {clean_r} was already sent recently (in-memory) — skipping.")
            continue
        _RATE_STATE["queue"].append({
            "recipient":       clean_r,
            "subject":         subject or "",
            "body":            body or "",
            "queued_at":       now,
            "unsubscribe_url": unsubscribe_url,  # None for common domains
        })
        queued_recips.add(clean_r)

def check_for_blocked_domain(email: str) -> bool:
    if "@" not in email:
        return True  # invalid email → block

    domain = email.split("@", 1)[1].lower()

    policy = get_email_policy()
    blocked_domains = policy.get("blocked_domains", [])

    return any(
        domain == blocked or domain.endswith(f".{blocked}")
        for blocked in blocked_domains
    )

def process_deferred_email_queue() -> Dict[str, Any]:
    """Send queued email jobs until quota is exhausted.

    Notes:
    - Jobs are stored in _RATE_STATE['queue'].
    - Each job is a dict: {recipient, subject, body, queued_at, unsubscribe_url}.
    - Uses _QUEUE_LOCK to ensure non-concurrent execution across threads.
    - On successful send, we increment _RATE_STATE['sent'] and pop the job.
    - On failure, we stop so it can retry in the next loop iteration.
    - A domain-aware inter-send delay is applied after each successful send
      to avoid triggering Gmail's bulk/automation spam detection.
    """
    global EMAIL_THREAD_SCHEDULE
    if isCreditsExpired:
        log.warning("Gmail credentials have expired; skipping process_deferred_email_queue.")
        return {"sent": 0, "queued": len(_RATE_STATE.get("queue", []) or []), "remaining_quota": 0, "window_start": _RATE_STATE.get("window_start")}

    acquired = _QUEUE_LOCK.acquire(blocking=False)
    if not acquired:
        log.info("[queue] process_deferred_email_queue already running in another thread — skipping concurrent execution.")
        return {
            "sent": 0,
            "queued": len(_RATE_STATE.get("queue", []) or []),
            "remaining_quota": _remaining_quota(),
            "window_start": _RATE_STATE.get("window_start")
        }

    try:
        _reset_window_if_needed()
        q = _RATE_STATE.get("queue", []) or []
        sent_now = 0

        # Determine domain type once per queue run (avoids repeated API calls)
        _init = initiator_email()
        _sender_is_common = is_common_domain(_init) if _init else True

        while q and _remaining_quota() > 0:
            job = q[0] or {}
            recipient = (job.get("recipient") or "").strip()
            subject = job.get("subject", "")
            body = job.get("body", "")
            if not recipient:
                q.pop(0)
                continue
            is_email_checked = check_for_blocked_domain(recipient)
            if is_email_checked:
                q.pop(0)
                continue
            # Skip opted-out recipients (catches all send paths, not just reminders)
            if recipient.lower() in _unsubscribed:
                log.info(f"[queue] {recipient} is unsubscribed — skipping.")
                q.pop(0)
                continue
            # Safeguard: check if email was already sent recently
            if _is_sent_recently_in_memory(recipient, subject):
                log.info(f"[queue] {recipient} was already sent recently (in-memory) — skipping queue job.")
                q.pop(0)
                continue
            try:
                unsubscribe_url = job.get("unsubscribe_url")  # None for common domains
                emailData = _send_email_raw(recipient, subject, body, unsubscribe_url=unsubscribe_url)
                current_time = int(time.time())
                EMAIL_THREAD_SCHEDULE = current_time + 3600
                if emailData is None:
                    # send failed; stop processing further
                    break
                sent_now += 1
                _RATE_STATE["sent"] = int(_RATE_STATE.get("sent", 0) or 0) + 1
                q.pop(0)

                # Inter-send delay (skip after last item to avoid blocking unnecessarily)
                if q:
                    if _sender_is_common:
                        delay = random.randint(30, 90)   # common domain: 30–90 s
                    else:
                        delay = random.randint(15, 30)   # custom domain:  15–30 s
                    log.info(f"[queue] Waiting {delay}s before next send (domain={'common' if _sender_is_common else 'custom'}).")
                    time.sleep(delay)

            except Exception as e:
                log.warning(f"[rate] Send failed (will retry later): {e}")
                break

            _RATE_STATE["queue"] = q
            _RATE_STATE["window_reset"] = False
        _RATE_STATE["queue"] = q

        return {
            "sent":            sent_now,
            "queued":          len(q),
            "remaining_quota": _remaining_quota(),
            "window_start":    _RATE_STATE.get("window_start"),
        }
    finally:
        _QUEUE_LOCK.release()

def send_email(recipients, subject: str, body: str, queued_set=None, unsubscribe_url: str = None) -> Dict[str, Any]:
    """Public entry-point for sending emails.

    Behavior:
    - Normalizes + de-dups recipients.
    - Enqueues one job per recipient.
    - Immediately processes the queue (sends up to remaining quota).

    Returns counters describing how many were sent now vs queued.
    """
    if isCreditsExpired:
        log.warning("Gmail credentials have expired; skipping send_email.")
        return {"sent": 0, "queued": 0, "remaining_quota": 0, "window_start": _RATE_STATE.get("window_start")}
    recips = _normalize_recipients(recipients)
    if not recips and not queued_set:
        return {"sent": 0, "queued": 0, "remaining_quota": _remaining_quota(), "window_start": _RATE_STATE.get("window_start")}
    _enqueue_individual_emails(recips, subject, body, unsubscribe_url=unsubscribe_url)
    return process_deferred_email_queue()

def get_email_policy() -> dict:
    global _email_policy
    if _email_policy is None:
        with _lock:
            if _email_policy is None:
                _email_policy = _load_email_policy_file()

    return _email_policy

def _load_email_policy_file() -> dict:
    blocked_domain_data = {}
    for path in (EMAIL_POLICY_FILE, FALLBACK_EMAIL_POLICY_FILE):
        if os.path.exists(path):
            with open(path, "r", encoding="utf-8") as f:
                blocked_domain_data = json.load(f)
    if not blocked_domain_data:
        blocked_domain_data = fetchBlockedDomainData()
        if blocked_domain_data:
            update_blocked_Domain_File_Using_Report(blocked_domain_data)
            return blocked_domain_data
    else:
        return blocked_domain_data
    return {
        "blocked_domains": []
    }

def update_blocked_Domain_File_Using_Report(blocked_domain_data):
    global _email_policy
    for path in (EMAIL_POLICY_FILE, FALLBACK_EMAIL_POLICY_FILE):
        os.makedirs(os.path.dirname(path), exist_ok=True)
        with open(path, "w", encoding="utf-8") as f:
            json.dump(blocked_domain_data, f)
    
    global _email_policy
    # with _lock:
    _email_policy = blocked_domain_data

def update_email_policy(blocked_domains: list[str]):
    global _email_policy
    data = {
        "blocked_domains": [
            d.lower().strip().lstrip("@") for d in blocked_domains
        ]
    }

    for path in (EMAIL_POLICY_FILE, FALLBACK_EMAIL_POLICY_FILE):
        os.makedirs(os.path.dirname(path), exist_ok=True)
        with open(path, "w", encoding="utf-8") as f:
            json.dump(data, f)
    
    send_blocked_Domain_log(data)
    bridge_log("blocked_domain_Updated", blockedDomains=data)
    global _email_policy
    with _lock:
        _email_policy = data

def _get_write_token_path():
    parent_dir = os.path.dirname(SECRET_TOKEN_FILE)
    if os.path.exists(SECRET_TOKEN_FILE):
        if os.access(SECRET_TOKEN_FILE, os.W_OK):
            return SECRET_TOKEN_FILE
    elif os.path.exists(parent_dir) and os.access(parent_dir, os.W_OK):
        return SECRET_TOKEN_FILE
    return FALLBACK_TOKEN_FILE

def _safe_write_token(creds_obj):
    write_path = _get_write_token_path()
    try:
        with open(write_path, "wb") as f:
            pickle.dump(creds_obj, f)
    except Exception as e:
        log.warning(f"Failed to write token to {write_path}: {e}")

def creds_ready() -> bool:
    """True when global creds exist and are usable.
    In deployed mode OAuth may complete AFTER process starts.
    """
    global creds
    try:
        if not creds:
            for path in (SECRET_TOKEN_FILE, FALLBACK_TOKEN_FILE):
                c = _load_creds_from_path(path)
                if c:
                    creds = c
                    break

        if not creds:
            return False
        # If expired but refreshable, refresh and persist.
        if getattr(creds, "expired", False) and getattr(creds, "refresh_token", None):
            try:
                creds.refresh(GoogleRequest())
                _safe_write_token(creds)
            except Exception as e:
                log.warning(f"[auth] refresh failed: {e}")
                return False

        return bool(getattr(creds, "valid", False))
    except Exception as e:
        log.warning(f"[auth] creds_ready check failed: {e}")
        return False


def wait_for_auth(poll_seconds: int = 3, log_every_seconds: int = 30) -> None:
    """Block until OAuth credentials are available/valid.
    Auth can happen any time (minutes/hours).
    """
    last_log = 0
    while not creds_ready():
        now = _now_epoch()
        if now - last_log >= log_every_seconds:
            last_log = now
            log.info("[auth] Waiting for OAuth… complete /auth flow")
            # try:
            #     bridge_log("auth_waiting")
            # except Exception:
            #     pass
        time.sleep(poll_seconds)

# --- Robust credentials loader supporting pickle or JSON ---
def _load_creds_from_path(path: str):
    """Robust credentials loader.
    Supports both:
    1) Pickled google Credentials objects (preferred)
    2) JSON produced by creds.to_json() / authorized user files
    If JSON is detected and successfully loaded, it will be re-saved as pickle
    to the same path for future runs.
    """
    if not path or not os.path.exists(path):
        return None

    # 1) Try pickle first
    try:
        with open(path, "rb") as f:
            obj = pickle.load(f)
        # Basic sanity: google creds usually have these attrs
        if obj and (hasattr(obj, "refresh") or hasattr(obj, "token")):
            return obj
    except Exception as e:
        log.warning(f"Failed to load credentials as pickle from {path}: {e}")

    # 2) Fallback: try JSON authorized user format
    try:
        with open(path, "r", encoding="utf-8") as f:
            data = json.load(f)
        creds_obj = GoogleCredentials.from_authorized_user_info(data, SCOPES)
        # Persist back as pickle for consistency
        try:
            with open(path, "wb") as wf:
                pickle.dump(creds_obj, wf)
        except Exception as e:
            log.warning(f"Failed to rewrite JSON token as pickle at {path}: {e}")
        return creds_obj
    except Exception as e:
        log.warning(f"Failed to load credentials as JSON from {path}: {e}")

    return None

# Load credentials: try secret first, then fallback
creds = None
for path in (SECRET_TOKEN_FILE, FALLBACK_TOKEN_FILE):
    creds = _load_creds_from_path(path)
    print(f"Loaded creds from {path}: {bool(creds)}")
    if creds:
        break

# Refresh if needed and persist
if creds and getattr(creds, "expired", False) and getattr(creds, "refresh_token", None):
    try:
        creds.refresh(GoogleRequest())
        _safe_write_token(creds)
    except Exception as e:
        log.warning(f"Failed to refresh credentials: {e}")

GROUP_EMAIL = "${groupEmail}"           # e.g. "my-team@googlegroups.com"
SHEET_URL   = "${sheetsUrl}"              # Full Google Sheet URL or ID injected at deploy time
def _sheet_id_from_url(url):
    import re
    m = re.search(r"/spreadsheets/d/([a-zA-Z0-9-_]+)", url or "")
    return m.group(1) if m else url
SHEET_ID    = _sheet_id_from_url(SHEET_URL)    # Extract ID if a URL was provided
TIME_ZONE   = os.getenv("TZ", "Asia/Kolkata")
Sessionid = ''
username = ''
MobileNumber = ''
forumID = "${forumID}" 
# Ensure go() starts only once per process
_go_thread_started = False

# Single field key used by the Unified Logs flow
ULOG_FIELD_KEY = '${TemplateName}_uLogs_Main-305d1e09-3f5c-a157-7757-564942913a9e_2'
BLOCKED_DOMAIN_FEILD_KEY = "${TemplateName}_BlockedDomains_Main-${bFID}_2"
DAILY_EMAIL_LIMIT_FEILD_KEY = "${TemplateName}_AddLimits_Main-${limitFID}"

def bridge_log(event: str, level: str = "info", **fields):
    """Send a structured JSON log to Cosmitude Bridge.

    This is best-effort (never breaks the agent) and is used for:
    - debugging sheet creation/sync
    - debugging Gmail message processing
    - tracking sending-window resets and queue behavior
    """
    try:
        payload = {
            "ts": local_dt_str(),
            "event": event,
            "level": level,
            "sessionId": Sessionid or "",
            "forumId": forumID,
            # "groupEmail": GROUP_EMAIL,
            **fields,
        }
        log_bytes = json.dumps(payload, ensure_ascii=False, default=str).encode("utf-8")
        sendData = { ULOG_FIELD_KEY: base64.b64encode(log_bytes).decode("utf-8") }
        sendBridge("", '${TemplateName}_uLogs', sendData)
    except Exception as e:
        logging.getLogger("gmail-agent").warning("bridge_log failed: %s", e)

def send_daily_email_limit_log(limit, type):
    try:
        sendData = {
            f"{DAILY_EMAIL_LIMIT_FEILD_KEY}_2": base64.b64encode(type).decode("utf-8"),
            f"{DAILY_EMAIL_LIMIT_FEILD_KEY}_4": base64.b64encode(limit).decode("utf-8")
        }
        sendDailyEmailLimitBridge("${TemplateName}_AddLimits", sendData)
    except Exception as e:
        logging.getLogger("store-email-limit").warning("email-limit storing failed: %s", e)

def send_blocked_Domain_log(domainsData):
    try:
        domain_bytes = json.dumps(domainsData, ensure_ascii=False, default=str).encode("utf-8")
        sendData = { BLOCKED_DOMAIN_FEILD_KEY: base64.b64encode(domain_bytes).decode("utf-8") }
        sendDominBlockedBridge("${TemplateName}_BlockedDomains", sendData)
    except Exception as e:
        logging.getLogger("store-blocked-domain").warning("blocked_domain storing failed: %s", e)

def go():
    try:
        global _CURRENT_THREAD_TAB
        # Call login only once at process start.
        # In deployed mode, OAuth may complete later.
        try:
            login()
        except Exception as e:
            log.warning(f"[go] login init failed (will wait for auth): {e}")

        setup_done = False

        while True:
            # If auth not ready, wait (can take minutes/hours).
            # if isCreditsExpired:
                # bridge_log("credentials_expired", level="error")
            if not creds_ready():
                wait_for_auth(poll_seconds=3, log_every_seconds=30)

            # One-time setup AFTER auth is ready
            if not setup_done:
                try:
                    ensure_status_tabs()
                    ensure_sent_log_sheet()
                    check_and_start_thread_if_missing()
                    try:
                        tab = latest_thread_tab()
                        _CURRENT_THREAD_TAB = tab
                        ensure_and_sync_thread_tab(tab)
                        # refresh_status_tabs_from_thread(tab)
                        ensure_status_tabs_formulas(tab)
                    except Exception as e:
                        log.warning(f"[go] initial pending/completed sync skipped: {e}")
                    setup_done = True
                    bridge_log("auth_ready", level="info")
                except Exception as e:
                    log.warning(f"[go] post-auth setup failed (will retry): {e}")
                    time.sleep(10)
                    continue

            # Normal loop AFTER auth
            try:
                if _RATE_STATE.pop("window_reset", False):
                    info = enqueue_remaining_pending_emails()
                    # bridge_log("window_reset_enqueue", **(info or {}))

                # process_deferred_email_queue()
            except Exception as e:
                log.warning(f"[go] process_deferred_email_queue failed: {e}")

            try:
                clienntSync()
            except Exception as e:
                log.warning(f"[go] clienntSync failed: {e}")

            time.sleep(10)

    except Exception as e:
        print(e)
        return e

# if not GROUP_EMAIL or not SHEET_ID:
if not SHEET_ID:
    raise RuntimeError("GROUP_EMAIL and SHEET_ID environment variables are required")


# --- Required imports for TLS/network retry ---
import ssl
import socket
import googleapiclient.discovery
# Toggle Google API verbosity via env; default to WARNING in production
if os.getenv("GOOGLE_API_DEBUG") == "1":
    logging.getLogger("googleapiclient.discovery").setLevel(logging.DEBUG)
    logging.getLogger("googleapiclient.http").setLevel(logging.DEBUG)
else:
    logging.getLogger("googleapiclient.discovery").setLevel(logging.WARNING)
    logging.getLogger("googleapiclient.http").setLevel(logging.WARNING)

# ---- Utility -------------------------------------------------------------- #
def safe_call(desc: str, request, max_retries: int = 8):
    for i in range(max_retries):
        try:
            with _GOOGLE_API_CALL_LOCK:
                return request()
        except HttpError as e:
            status = getattr(e.resp, "status", None)
            if status in (429, 503):
                sleep = min(60, (2 ** i)) + random.random()
                log.warning(f"[Sheets] {desc} rate-limited ({status}); retry in {sleep:.2f}s")
                time.sleep(sleep)
                continue
            log.error(f"[Sheets] {desc} failed: {e}", exc_info=True)
            # bridge_log("sheets_call_error", level="error", desc=desc, error=str(e))
            raise
        except (ssl.SSLError, socket.timeout, TimeoutError, ConnectionResetError, BrokenPipeError) as e:
            # Handles BAD_RECORD_MAC / DECRYPTION_FAILED and other transient TLS/socket issues
            sleep = min(60, (2 ** i)) + random.random()
            log.warning(f"[Sheets] {desc} transient TLS/network error: {e}; retry in {sleep:.2f}s")
            _reset_google_services()  # rebuild http pool on next call
            time.sleep(sleep)
            continue

        except OSError as e:
            sleep = min(60, (2 ** i)) + random.random()
            log.warning(f"[Sheets] {desc} OS/network error: {e}; retry in {sleep:.2f}s")
            _reset_google_services()
            time.sleep(sleep)
            continue

        except Exception as e:
            log.error(f"[Sheets] {desc} failed: {e}", exc_info=True)
            # bridge_log("sheets_call_error", level="error", desc=desc, error=str(e))
            raise

    raise RuntimeError(f"[Sheets] {desc} retries exhausted")

# ---------------- OAuth2 / Google API helpers ---------------- #
_GMAIL_SVC = None
_SHEETS_SVC = None
_SVC_LOCK = Lock()
# Google API clients (httplib2/AuthorizedHttp under the hood) are not thread-safe.
# Serialize Google API calls to avoid TLS record layer corruption under multi-threading.
_GOOGLE_API_CALL_LOCK = Lock()

def _reset_google_services():
    """Drop cached Google API service objects so they are rebuilt on next call."""
    global _GMAIL_SVC, _SHEETS_SVC, _INITIATOR_EMAIL_CACHE
    with _SVC_LOCK:
        _GMAIL_SVC = None
        _SHEETS_SVC = None
    # Also clear derived caches that depend on the service
    _INITIATOR_EMAIL_CACHE = None

def gmail_service():
    global creds
    global _GMAIL_SVC
    # Try refresh first (covers cases where valid=False because token expired)
    if creds and getattr(creds, "expired", False) and getattr(creds, "refresh_token", None):
        try:
            creds.refresh(GoogleRequest())
            _safe_write_token(creds)
        except Exception as e:
            log.warning(f"[auth] gmail refresh failed: {e}")

    if not creds or not getattr(creds, "valid", False):
        log.warning("[auth] gmail_service called without valid creds")
        # bridge_log("gmail_service_unauthorized", level="warn")
        raise HTTPException(403, "Not authorised – visit /auth")

    with _SVC_LOCK:
        if _GMAIL_SVC is None:
            try:
                _GMAIL_SVC = build("gmail", "v1", credentials=creds, cache_discovery=False)
            except Exception as e:
                log.warning(f"[auth] gmail build failed (will reset + retry later): {e}")
                _reset_google_services()
                raise
    return _GMAIL_SVC

_INITIATOR_EMAIL_CACHE = None

def initiator_email() -> str:
    global _INITIATOR_EMAIL_CACHE
    if _INITIATOR_EMAIL_CACHE:
        return _INITIATOR_EMAIL_CACHE
    # Guard: only attempt if credentials are loaded and valid
    if not creds or not getattr(creds, 'valid', False):
        return ""
    try:
        svc = gmail_service()
        profile = svc.users().getProfile(userId="me").execute()
        _INITIATOR_EMAIL_CACHE = (profile.get("emailAddress") or "").strip().lower()
        domain_type = 'common' if is_common_domain(_INITIATOR_EMAIL_CACHE) else 'custom'
        log.info(f"[initiator_email] email={_INITIATOR_EMAIL_CACHE} domain_type={domain_type}")
        return _INITIATOR_EMAIL_CACHE
    except Exception as e:
        log.warning(f"[initiator_email] Could not fetch profile: {e}")
        return ""

# --- Status-tab syncing (only used when USE_STATUS_FORMULAS is disabled) ---
_STATUS_EMAILS_CACHE = {
    "ts": 0,
    "pending": set(),
    "completed": set(),
}
_STATUS_EMAILS_CACHE_TTL = int(os.getenv("STATUS_EMAILS_CACHE_TTL", "30"))


def _is_tracker_tab(tab_name: str) -> bool:
    """Heuristic: treat the run/email tracker tab as the 'source of truth' tab."""
    t = (tab_name or "").strip()
    if not t:
        return False
    # Matches your run tabs (EmailTracker_Run_001, etc.)
    if THREAD_TAB_BASENAME and t.startswith(THREAD_TAB_BASENAME):
        return True
    # Common direct tab name
    if t.lower() in ("emailtracker", "email tracker"):
        return True
    # Fallback: anything starting with EmailTracker*
    if t.lower().startswith("emailtracker"):
        return True
    return False


def _read_existing_emails(tab_name: str) -> set:
    """Read existing emails from column A of the given sheet tab."""
    ss = sheets_service()
    resp = safe_call(
        f"read existing emails from {tab_name}",
        ss.spreadsheets().values().get(
            spreadsheetId=SHEET_ID,
            range=f"{tab_name}!A2:A",
        ).execute,
    )
    rows = resp.get("values", []) or []
    out = set()
    for r in rows:
        if not r:
            continue
        addr = parseaddr(r[0] or "")[1].lower().strip()
        if addr:
            out.add(addr)
    return out


def _get_status_email_set(which: str) -> set:
    """Return cached email set for 'pending' or 'completed'."""
    now = _now_epoch()
    ts = int(_STATUS_EMAILS_CACHE.get("ts", 0) or 0)
    if (now - ts) <= _STATUS_EMAILS_CACHE_TTL and _STATUS_EMAILS_CACHE.get(which):
        return _STATUS_EMAILS_CACHE[which]

    # Refresh both together to keep cache coherent
    try:
        pending = _read_existing_emails(PENDING_TAB_NAME)
    except Exception:
        pending = set()
    try:
        completed = _read_existing_emails(COMPLETED_TAB_NAME)
    except Exception:
        completed = set()

    _STATUS_EMAILS_CACHE["ts"] = now
    _STATUS_EMAILS_CACHE["pending"] = pending
    _STATUS_EMAILS_CACHE["completed"] = completed
    return _STATUS_EMAILS_CACHE[which]


def _invalidate_status_email_cache() -> None:
    _STATUS_EMAILS_CACHE["ts"] = 0
    _STATUS_EMAILS_CACHE["pending"] = set()
    _STATUS_EMAILS_CACHE["completed"] = set()


def _append_rows_bulk_raw(tab: str, rows):
    """Low-level bulk append without any extra syncing logic."""
    if not tab or not rows:
        return

    if tab == SENT_LOG_TAB_NAME:
        _invalidate_sentlog_count_cache()

    ss = sheets_service()
    safe_call(
        "bulk append rows",
        ss.spreadsheets().values().append(
            spreadsheetId=SHEET_ID,
            range=f"{tab}!A2",
            valueInputOption="RAW",
            insertDataOption="INSERT_ROWS",
            body={"values": rows},
        ).execute,
    )


def append_rows_bulk(tab: str, rows):
    """High-level bulk append.

    Requirement:
    - Your code writes Email IDs into the EmailTracker (run) tab from another 'main' tab.
    - Whenever a row is appended into the EmailTracker/run tab with Status=Pending,
      the SAME row should also be appended into the Pending tab.

    Implementation:
    - If USE_STATUS_FORMULAS is enabled, Pending/Completed are formula-driven views,
      so we do NOT append to them directly.
    - If USE_STATUS_FORMULAS is disabled, we mirror new rows into Pending/Completed
      based on the Status column.
    """
    if not tab or not rows:
        return

    # 1) Always append to the requested tab.
    _append_rows_bulk_raw(tab, rows)

    # 2) If formulas are used, Pending/Completed are views; nothing else to do.
    if USE_STATUS_FORMULAS:
        return

    # 3) Mirror tracker rows into Pending/Completed.
    # Avoid recursion and avoid syncing when writing INTO status tabs.
    if tab in (PENDING_TAB_NAME, COMPLETED_TAB_NAME):
        return

    if not _is_tracker_tab(tab):
        return

    # 4) Dedup by Email (column A). We only mirror unique emails.
    try:
        pending_existing = _get_status_email_set("pending")
        completed_existing = _get_status_email_set("completed")
    except Exception:
        pending_existing, completed_existing = set(), set()

    pending_to_add = []
    completed_to_add = []

    for r in (rows or []):
        if not r:
            continue
        email = parseaddr((r[0] if len(r) > 0 else "") or "")[1].lower().strip()
        status = (r[2] if len(r) > 2 else "")
        status_norm = (str(status or "").strip().lower())
        if not email:
            continue

        if status_norm == "pending":
            if email not in pending_existing:
                pending_existing.add(email)
                pending_to_add.append(r)
        elif status_norm == "completed":
            if email not in completed_existing:
                completed_existing.add(email)
                completed_to_add.append(r)

    if pending_to_add:
        _append_rows_bulk_raw(PENDING_TAB_NAME, pending_to_add)
    if completed_to_add:
        _append_rows_bulk_raw(COMPLETED_TAB_NAME, completed_to_add)

    # Keep cache consistent
    _STATUS_EMAILS_CACHE["ts"] = _now_epoch()
    _STATUS_EMAILS_CACHE["pending"] = pending_existing
    _STATUS_EMAILS_CACHE["completed"] = completed_existing

def sheets_service():
    global creds
    global _SHEETS_SVC
    # Try refresh first (covers cases where valid=False because token expired)
    if creds and getattr(creds, "expired", False) and getattr(creds, "refresh_token", None):
        try:
            creds.refresh(GoogleRequest())
            _safe_write_token(creds)
        except Exception as e:
            log.warning(f"[auth] sheets refresh failed: {e}")

    if not creds or not getattr(creds, "valid", False):
        log.warning("[auth] sheets_service called without valid creds")
        # bridge_log("sheets_service_unauthorized", level="warn")
        raise HTTPException(403, "Not authorised – visit /auth")

    with _SVC_LOCK:
        if _SHEETS_SVC is None:
            try:
                # http = _authorized_http(timeout=60)
                _SHEETS_SVC = build("sheets", "v4", credentials=creds, cache_discovery=False)
            except Exception as e:
                log.warning(f"[auth] sheets build failed (will reset + retry later): {e}")
                _reset_google_services()
                raise
    return _SHEETS_SVC

def get_group_members():
    """Return a list of primary e‑mail addresses for all members of the GROUP_EMAIL."""
    return []

# ---------------- Spreadsheet helpers ---------------- #
HEADER = ['Email', 'ThreadID', 'Status', 'LastReply']
# Fixed status tabs (kept in sync with the latest thread tab)
PENDING_TAB_NAME = os.getenv("PENDING_TAB_NAME", "Pending")
COMPLETED_TAB_NAME = os.getenv("COMPLETED_TAB_NAME", "Completed")
USE_STATUS_FORMULAS = os.getenv("USE_STATUS_FORMULAS", "0") in ("1","true","True","TRUE")

SENT_LOG_TAB_NAME = os.getenv("SENT_LOG_TAB_NAME", "SentLog")
SUCCESS_MAIL_TAB_NAME = os.getenv("SUCCESS_MAIL_TAB_NAME", "Success_Mail")
FAILED_MAIL_TAB_NAME = os.getenv("FAILED_MAIL_TAB_NAME", "Failed_Mail")
# SentLog is append-only. It helps us know who was already emailed and supports
# resuming sending on the next rate-limit window without re-emailing everyone.
SENT_LOG_HEADER = ["Timestamp", "Recipient", "Subject", "MessageId", "ThreadId", "Result", "Error"]
STATUS_LOG_HEADER = ["Timestamp", "Recipient", "Subject", "MessageId", "Result", "Reason"]

def ensure_sheet(tab_name: str):
    """Ensure a Thread/Run tab exists with HEADER and seed from Main roster if newly created."""
    ss = sheets_service()
    # Fetch spreadsheet metadata once
    meta = safe_call("get spreadsheet meta", ss.spreadsheets().get(spreadsheetId=SHEET_ID).execute)
    existing_tabs = {s['properties']['title'] for s in meta.get('sheets', [])}
    if tab_name not in existing_tabs:
        safe_call("addSheet", ss.spreadsheets().batchUpdate(
            spreadsheetId=SHEET_ID,
            body={"requests": [{
                "addSheet": {"properties": {"title": tab_name}}
            }]}
        ).execute)
        # Write header row
        safe_call("write header", ss.spreadsheets().values().update(
            spreadsheetId=SHEET_ID,
            range=f"{tab_name}!A1",
            valueInputOption='RAW',
            body={'values': [HEADER]}
        ).execute)
        bridge_log("sheet_created", tab=tab_name)
        # Seed the new tab with emails from the detected main roster tab (if any)
        try:
            seed_new_tab_from_main(tab_name)
        except Exception as e:
            log.warning(f"[ensure_sheet] seed_new_tab_from_main failed: {e}")

def ensure_simple_sheet(tab_name: str):
    """Create a sheet with HEADER if it doesn't exist. Does NOT seed any data."""
    if not tab_name:
        return
    ss = sheets_service()
    meta = safe_call("get spreadsheet meta", ss.spreadsheets().get(spreadsheetId=SHEET_ID).execute)
    existing_tabs = {s['properties']['title'] for s in meta.get('sheets', [])}
    if tab_name not in existing_tabs:
        safe_call("addSheet", ss.spreadsheets().batchUpdate(
            spreadsheetId=SHEET_ID,
            body={"requests": [{"addSheet": {"properties": {"title": tab_name}}}]}
        ).execute)
        # if tab_name not in (PENDING_TAB_NAME):
        safe_call("write header", ss.spreadsheets().values().update(
            spreadsheetId=SHEET_ID,
            range=f"{tab_name}!A1",
            valueInputOption="RAW",
            body={"values": [HEADER]}
        ).execute)
        bridge_log("sheet_created", tab=tab_name)

def ensure_sent_log_sheet():
    """Create SentLog sheet with its own header if it doesn't exist."""
    if not SENT_LOG_TAB_NAME:
        return
    ss = sheets_service()
    meta = safe_call("get spreadsheet meta", ss.spreadsheets().get(spreadsheetId=SHEET_ID).execute)
    existing_tabs = {s['properties']['title'] for s in meta.get('sheets', [])}
    if SENT_LOG_TAB_NAME not in existing_tabs:
        safe_call("addSheet", ss.spreadsheets().batchUpdate(
            spreadsheetId=SHEET_ID,
            body={"requests": [{"addSheet": {"properties": {"title": SENT_LOG_TAB_NAME}}}]}
        ).execute)
        safe_call("write sent log header", ss.spreadsheets().values().update(
            spreadsheetId=SHEET_ID,
            range=f"{SENT_LOG_TAB_NAME}!A1",
            valueInputOption="RAW",
            body={"values": [SENT_LOG_HEADER]}
        ).execute)
        bridge_log("sheet_created", tab=SENT_LOG_TAB_NAME)

def _quote_sheet_name(name: str) -> str:
    safe = (name or "").replace("'", "''")
    return f"'{safe}'"

def ensure_status_tabs_formulas(thread_tab: str) -> None:
    """Make Pending/Completed auto-populate from the given thread tab using formulas."""
    if not thread_tab:
        return

    ss = sheets_service()
    qt = _quote_sheet_name(thread_tab)

    pending_formula = (
        f'={{"Email","ThreadID","Status","LastReply";'
        f'FILTER({qt}!A2:D, LOWER({qt}!C2:C)<>"completed")}}'
    )
    completed_formula = (
        f'={{"Email","ThreadID","Status","LastReply";'
        f'FILTER({qt}!A2:D, LOWER({qt}!C2:C)="completed")}}'
    )

    # IMPORTANT: USER_ENTERED so formulas evaluate
    safe_call(
        "set Pending formula",
        ss.spreadsheets().values().update(
            spreadsheetId=SHEET_ID,
            range=f"{PENDING_TAB_NAME}!A1",
            valueInputOption="USER_ENTERED",
            body={"values": [[pending_formula]]},
        ).execute,
    )

    safe_call(
        "set Completed formula",
        ss.spreadsheets().values().update(
            spreadsheetId=SHEET_ID,
            range=f"{COMPLETED_TAB_NAME}!A1",
            valueInputOption="USER_ENTERED",
            body={"values": [[completed_formula]]},
        ).execute,
    )
def sync_status_tabs_from_thread(thread_tab: str) -> None:
    if USE_STATUS_FORMULAS:
        ensure_status_tabs_formulas(thread_tab)
    else:
        refresh_status_tabs_from_thread(thread_tab)  # fallback

def append_sent_log(recipient: str, subject: str, message_id: str = "", thread_id: str = "",
                    result: str = "sent", error: str = ""):
    """Append a row into SentLog. Best-effort; never raises."""
    try:
        ensure_sent_log_sheet()
        ss = sheets_service()
        ts = iso_now_local()
        safe_call("append sent log", ss.spreadsheets().values().append(
            spreadsheetId=SHEET_ID,
            range=f"{SENT_LOG_TAB_NAME}!A2",
            valueInputOption="RAW",
            insertDataOption="INSERT_ROWS",
            body={"values": [[
                ts,
                recipient or "",
                (subject or "")[:200],
                message_id or "",
                thread_id or "",
                result or "",
                (error or "")[:500],
            ]]}
        ).execute)
    except Exception as e:
        log.warning(f"[SentLog] append failed: {e}")

def clear_and_write_rows(tab_name: str, rows: list[list[str]]):
    """Clear the tab and write HEADER + rows into the given tab.

    Note: If the sheet includes a Timestamp/Time/Date column, we normalize those
    cells to LOCAL timezone strings so the spreadsheet always shows local time.
    """
    if not tab_name:
        return
    ss = sheets_service()

    last_col = _col_letter(len(HEADER))
    safe_call("clear tab", ss.spreadsheets().values().clear(
        spreadsheetId=SHEET_ID,
        range=f"{tab_name}!A:{last_col}",
        body={}
    ).execute)
    time_cols: list[int] = []
    for i, h in enumerate(HEADER):
        hl = str(h or "").strip().lower()
        if any(k in hl for k in ("time", "timestamp", "date", "lastreply", "last reply")):
            time_cols.append(i)

    fixed_rows: list[list[str]] = []
    for r in (rows or []):
        rr = list(r or [])
        # pad/truncate to header width
        if len(rr) < len(HEADER):
            rr.extend([""] * (len(HEADER) - len(rr)))
        if len(rr) > len(HEADER):
            rr = rr[:len(HEADER)]

        # Convert timestamp cells to LOCAL time
        for idx in time_cols:
            if idx < len(rr) and rr[idx]:
                rr[idx] = _sheet_local_ts(rr[idx])

        fixed_rows.append(rr)

    values = [HEADER] + fixed_rows
    safe_call("write tab", ss.spreadsheets().values().update(
        spreadsheetId=SHEET_ID,
        range=f"{tab_name}!A1",
        valueInputOption="RAW",
        body={"values": values}
    ).execute)

def ensure_status_tabs():
    """Ensure Pending and Completed tabs exist (these are derived views, not authoritative)."""
    ensure_simple_sheet(PENDING_TAB_NAME)
    ensure_simple_sheet(COMPLETED_TAB_NAME)

def refresh_status_tabs_from_thread(thread_tab: str):
    """Rebuild Pending and Completed tabs from the latest thread/run tab rows."""
    if not thread_tab:
        return
    ensure_status_tabs()
    rows = get_rows(thread_tab)  # A2:D

    pending_rows: list[list[str]] = []
    completed_rows: list[list[str]] = []

    for r in rows or []:
        email = r[0] if len(r) > 0 else ""
        tid = r[1] if len(r) > 1 else ""
        status = (r[2] if len(r) > 2 else "pending")
        last = r[3] if len(r) > 3 else ""

        s = str(status or "").strip().lower()
        if s == "completed":
            completed_rows.append([email, tid, "completed", last])
        else:
            pending_rows.append([email, tid, "pending", last])

    clear_and_write_rows(PENDING_TAB_NAME, pending_rows)
    clear_and_write_rows(COMPLETED_TAB_NAME, completed_rows)
    # bridge_log("status_tabs_refreshed", threadTab=thread_tab, pending=len(pending_rows), completed=len(completed_rows))

def _all_tab_titles():
    ss = sheets_service()
    meta = safe_call("get spreadsheet meta", ss.spreadsheets().get(spreadsheetId=SHEET_ID).execute)
    return [s['properties']['title'] for s in meta.get('sheets', [])]

def _extract_timestamp_portion(title: str) -> str:
    """Legacy support: extract timestamp portion from title if it looks like Run_YYYY-..."""
    if not title:
        return ""
    t = str(title).strip()
    if "_" in t:
        _, rest = t.split("_", 1)
        return rest.strip()
    return t

def _is_timestamp_tab(title: str) -> bool:
    """Legacy support: treat YYYY-MM-DD or YYYY-MM-DD-HHMMSS tabs (optionally prefixed) as thread tabs."""
    ts = _extract_timestamp_portion(title)
    if not ts or len(ts) < 10:
        return False
    return (ts[4] == "-" and ts[7] == "-")

def _extract_run_index(title: str) -> Optional[int]:
    """Return integer run index if title matches '<BASENAME>_NNN'."""
    if not title:
        return None
    t = str(title).strip()
    base = (THREAD_TAB_BASENAME or "").strip()
    if not base:
        return None
    prefix = base + "_"
    if not t.startswith(prefix):
        return None
    suffix = t[len(prefix):].strip()
    if not suffix.isdigit():
        return None
    try:
        return int(suffix)
    except Exception:
        return None

def _is_thread_tab(title: str) -> bool:
    """Thread/run tabs include new sequential run tabs OR legacy timestamp tabs."""
    return (_extract_run_index(title) is not None) or _is_timestamp_tab(title)

def _make_thread_tab_name(run_index: int) -> str:
    width = THREAD_TAB_INDEX_WIDTH if THREAD_TAB_INDEX_WIDTH and THREAD_TAB_INDEX_WIDTH > 0 else 3
    base = (THREAD_TAB_BASENAME or "EmailTracker_Run").strip() or "EmailTracker_Run"
    return f"{base}_{run_index:0{width}d}"

def detect_main_tab_name() -> Optional[str]:
    """
    Main roster tab = the authoritative list of recipient emails.
    Detect the "main" roster tab automatically.
    Rules:
    - Exclude timestamp-like thread tabs.
    - Prefer the first remaining non-timestamp tab.
    - If nothing fits, return None.
    """
    try:
        titles = _all_tab_titles()
    except Exception:
        titles = []

    excluded = {
        str(PENDING_TAB_NAME).strip().lower(),
        str(COMPLETED_TAB_NAME).strip().lower(),
        str(SENT_LOG_TAB_NAME).strip().lower(),
    }
    non_thread = [
        t for t in titles
        if (not _is_thread_tab(t)) and (str(t).strip().lower() not in excluded)
    ]
    if not non_thread:
        return None
    # Prefer a tab literally named "Main" if it exists, but do not require it.
    for t in non_thread:
        if str(t).strip().lower() == "main":
            return t

    return non_thread[0]

_SENTLOG_RECIP_SUBJ_CACHE = {"ts": 0, "set": set()}
_SENTLOG_RECIP_SUBJ_TTL_SECONDS = int(os.getenv("SENTLOG_RECIP_SUBJ_TTL_SECONDS", "30"))

def _normalize_email(addr: str) -> str:
    return parseaddr(addr or "")[1].lower().strip()

def sent_pairs_recent(within_seconds: int = EMAIL_WINDOW_SECONDS) -> set[tuple[str, str]]:
    """
    Return {(recipient_email, subject_lower)} for emails sent within the last within_seconds.
    SentLog columns assumed:
      A=Timestamp, B=Recipient, C=Subject
    """
    now = int(time.time())
    ts = int(_SENTLOG_RECIP_SUBJ_CACHE.get("ts", 0) or 0)
    cached = _SENTLOG_RECIP_SUBJ_CACHE.get("set")

    if (now - ts) <= _SENTLOG_RECIP_SUBJ_TTL_SECONDS and isinstance(cached, set) and cached:
        return cached

    ensure_sent_log_sheet()
    ss = sheets_service()
    resp = safe_call(
        "read sentlog ts+recipient+subject",
        ss.spreadsheets().values().get(
            spreadsheetId=SHEET_ID,
            range=f"{SENT_LOG_TAB_NAME}!A2:C"
        ).execute
    )
    rows = resp.get("values", []) or []

    cutoff = now_local() - timedelta(seconds=within_seconds)
    out: set[tuple[str, str]] = set()

    for r in rows:
        if not r:
            continue
        ts_val = r[0] if len(r) > 0 else None
        recip = _normalize_email(r[1] if len(r) > 1 else "")
        subj = str(r[2] if len(r) > 2 else "").strip().lower()
        if not recip or not subj:
            continue

        dt = _parse_sentlog_ts(ts_val)
        if not dt:
            continue
        if dt >= cutoff:
            out.add((recip, subj))

    # Supplement with in-memory sent items
    for k, ts_val in list(_RECENTLY_SENT_IN_MEMORY.items()):
        if "||" in k and (now - ts_val) <= within_seconds:
            parts = k.split("||", 1)
            out.add((parts[0], parts[1]))

    _SENTLOG_RECIP_SUBJ_CACHE["ts"] = now
    _SENTLOG_RECIP_SUBJ_CACHE["set"] = out
    return out

def get_emails_from_tab(tab_name: str) -> list[str]:
    """Return unique recipient emails from a tab’s column A.

    Notes:
    - This reads A1:A so the Main roster can be headerless.
    - We normalize emails and de-duplicate while preserving order.
    """
    if not tab_name:
        return []
    ss = sheets_service()
    try:
        resp = safe_call(
            "read roster emails",
            ss.spreadsheets().values().get(
                spreadsheetId=SHEET_ID,
                range=f"{tab_name}!A1:A"
            ).execute,)
    except Exception as e:
        log.warning(f"[get_emails_from_tab] Failed reading {tab_name}: {e}")
        return []

    values = resp.get("values", []) or []
    emails: list[str] = []
    for row in values:
        if not row:
            continue
        e = _normalize_email(row[0])
        if e and "@" in e:
            emails.append(e)

    # de-dup while preserving order
    seen = set()
    uniq: list[str] = []
    for e in emails:
        if e in seen:
            continue
        seen.add(e)
        uniq.append(e)
    return uniq

def get_sentlog_threadid_of_day_set() -> set[str]:
    """Return thread IDs from SentLog for last 24 hours only."""
    try:
        ensure_sent_log_sheet()
        ss = sheets_service()
        resp = safe_call(
            "read sentlog last 24h",
            ss.spreadsheets().values().get(
                spreadsheetId=SHEET_ID,
                range=f"{SENT_LOG_TAB_NAME}!A2:E"
            ).execute,
        )
        values = resp.get("values", []) or []
        cutoff = int(time.time()) - EMAIL_WINDOW_SECONDS  # 24 hours ago
        out = set()
        for row in values:
            if len(row) < 5:
                continue

            try:
                # print(f" cutoff: {row}")
                ts = datetime.fromisoformat(row[0])  # timezone-aware
                ts_unix = int(ts.timestamp())  # Column A = timestamp
            except:
                continue

            if ts_unix >= cutoff:
                tid = str(row[4]).strip()  # Column E
                if tid:
                    out.add(tid)

        return out

    except Exception as e:
        log.warning(f"[SentLog] failed to read thread IDs: {e}")
        return set()

def get_sentlog_recipients_set() -> set[str]:
    """Return a set of normalized recipient emails present in SentLog (column B)."""
    try:
        ensure_sent_log_sheet()
        ss = sheets_service()
        resp = safe_call(
            "read sentlog recipients",
            ss.spreadsheets().values().get(
                spreadsheetId=SHEET_ID,
                range=f"{SENT_LOG_TAB_NAME}!B2:B"
            ).execute,
        )
        values = resp.get("values", []) or []
        out = set()
        for row in values:
            if not row:
                continue
            e = _normalize_email(row[0])
            if e:
                out.add(e)

        # Supplement with in-memory sent items
        now = _now_epoch()
        for k, ts_val in list(_RECENTLY_SENT_IN_MEMORY.items()):
            if "||" not in k and (now - ts_val) <= EMAIL_WINDOW_SECONDS:
                out.add(k)

        return out
    except Exception as e:
        log.warning(f"[SentLog] failed to read recipients: {e}")
        return set()


def enqueue_remaining_pending_emails(
    subject: Optional[str] = None,
    body: Optional[str] = None,
    prepare: bool = True,
    respect_sentlog: bool = True,
) -> Dict[str, Any]:
    """Enqueue/send reminders for recipients still pending.

    Remaining = emails present in Pending tab but NOT present in SentLog.
    Called only on sending-window reset so we continue sending the next batch “tomorrow”.
    """
    if isCreditsExpired:
        return {"enqueued": 0, "pending": 0, "reason": "credits_expired"}
    tab = prepare_run_state() if prepare else latest_thread_tab()
    subj = (subject or REMINDER_EMAIL_SUBJECT or "").strip()
    msg_body = (body or REMINDER_EMAIL_BODY or "").strip()
    ensure_status_tabs()
    ensure_sent_log_sheet()

    pending_emails = get_emails_from_tab(PENDING_TAB_NAME)
    if not pending_emails:
        return {"enqueued": 0, "pending": 0, "reason": "no_pending"}

    sent_set = get_sentlog_recipients_set() if respect_sentlog else set()

    # avoid enqueueing duplicates already in queue
    queued_set = set()
    for job in (_RATE_STATE.get("queue", []) or []):
        if isinstance(job, dict):
            r = _normalize_email(job.get("recipient", ""))
            if r:
                queued_set.add(r)

    remaining = []
    for e in pending_emails:
        ne = _normalize_email(e)
        if not ne:
            continue
        if ne in sent_set:
            continue
        if ne in queued_set:
            continue
        remaining.append(ne)

    # Filter out unsubscribed recipients from pending list
    from_addr = initiator_email()
    _enq_sender_is_common = is_common_domain(from_addr) if from_addr else True
    unsubscribe_url = (
        None if _enq_sender_is_common
        else f"{UNSUBSCRIBE_BASE_URL}?email={{email}}"
    )

    remaining = [ne for ne in remaining if ne not in _unsubscribed]
    if not remaining and not queued_set:
        return {"enqueued": 0, "pending": len(pending_emails), "reason": "nothing_remaining"}

    # ✅ will send up to quota and keep rest in queue
    _load_email_limit_file()
    # Pass per-recipient unsubscribe URL via keyword arg (uses UNSUBSCRIBE_BASE_URL template per recipient)
    res = send_email(remaining, subj, msg_body, queued_set, unsubscribe_url=None if _enq_sender_is_common else UNSUBSCRIBE_BASE_URL) or {}
    return {
        "enqueued": len(remaining),
        "pending": len(pending_emails),
        "sent_now": res.get("sent", 0),
        "queued_now": res.get("queued", 0),
        "remaining_quota": res.get("remaining_quota"),
        "respect_sentlog": respect_sentlog,
    }

def seed_new_tab_from_main(tab_name: str):
    """Copy emails from the detected main roster tab into a newly created thread tab."""
    if not tab_name:
        return

    main_tab = detect_main_tab_name()
    if not main_tab:
        return

    if main_tab == tab_name:
        return

    main_emails = get_emails_from_tab(main_tab)
    if not main_emails:
        return

    added = 0
    with _SHEET_WRITE_LOCK:
        existing = _get_tab_emails_set(tab_name)
        rows_to_add = []
        for e in main_emails:
            ne = _normalize_email(e)
            if not ne or ne in existing:
                continue
            rows_to_add.append([
                ne,
                "—",
                "pending",
                local_dt_str(),
            ])
            existing.add(ne)

        if rows_to_add:
            try:
                append_rows_bulk(tab_name, rows_to_add)
                added = len(rows_to_add)
            except Exception as e:
                log.warning(f"[seed_new_tab_from_main] Failed to bulk append {len(rows_to_add)} rows: {e}")

    if added:
        bridge_log("tab_seeded_from_main", tab=tab_name, mainTab=main_tab, added=added)

def _get_tab_emails_set(tab_name: str) -> set[str]:
    """Return a set of normalized emails already present in the given tab (column A, excluding header)."""
    try:
        rows = get_rows(tab_name)  # reads A2:D
    except Exception:
        rows = []

    existing = set()
    for row in rows or []:
        if not row:
            continue
        e = _normalize_email(row[0] if len(row) > 0 else "")
        if e:
            existing.add(e)
    return existing

def sync_tab_emails_from_main(tab_name: str):
    """
    Ensure '<tab_name>' contains ALL emails from the detected main roster tab.
    - Adds missing emails (does NOT remove anything).
    """
    if not tab_name:
        return

    main_tab = detect_main_tab_name()
    if not main_tab or main_tab == tab_name:
        return

    main_emails = get_emails_from_tab(main_tab)
    if not main_emails:
        return

    existing = _get_tab_emails_set(tab_name)

    added = 0
    rows_to_add = []
    for e in main_emails:
        ne = _normalize_email(e)
        if not ne or ne in existing:
            continue
        rows_to_add.append([
            ne,
            "—",
            "pending",
            local_dt_str(),
        ])
        existing.add(ne)

    if rows_to_add:
        try:
            append_rows_bulk(tab_name, rows_to_add)
            added = len(rows_to_add)
        except Exception as e:
            log.warning(f"[sync_tab_emails_from_main] Failed to bulk append {len(rows_to_add)} rows: {e}")

    if added:
        bridge_log("tab_synced_from_main", tab=tab_name, mainTab=main_tab, added=added)

def ensure_and_sync_thread_tab(tab_name: str):
    """Create thread tab if missing, sync roster emails, and refresh Pending/Completed tabs."""
    if isCreditsExpired:
        return
    if not tab_name:
        return
    ensure_sheet(tab_name)
    try:
        sync_tab_emails_from_main(tab_name)
    except Exception as e:
        log.warning(f"[ensure_and_sync_thread_tab] sync_tab_emails_from_main failed: {e}")
    try:
        sync_status_tabs_from_thread(tab_name)
    except Exception as e:
        log.warning(f"[ensure_and_sync_thread_tab] refresh_status_tabs_from_thread failed: {e}")

def latest_thread_tab():
    global _CURRENT_THREAD_TAB
    with _THREAD_TAB_LOCK:
        if _CURRENT_THREAD_TAB:
            try:
                if _CURRENT_THREAD_TAB in _all_tab_titles():
                    return _CURRENT_THREAD_TAB
            except Exception:
                return _CURRENT_THREAD_TAB

        titles = _all_tab_titles()

        # 1) Prefer sequential run tabs
        run_tabs: list[tuple[int, str]] = []
        for t in titles:
            idx = _extract_run_index(t)
            if idx is not None:
                run_tabs.append((idx, t))
        if run_tabs:
            run_tabs.sort(key=lambda x: x[0])
            _CURRENT_THREAD_TAB = run_tabs[-1][1]
            return _CURRENT_THREAD_TAB

        # 2) Fallback to legacy timestamp tabs (if any)
        legacy = [t for t in titles if _is_timestamp_tab(t)]
        if legacy:
            legacy_sorted = sorted(legacy, key=lambda x: _extract_timestamp_portion(x))
            _CURRENT_THREAD_TAB = legacy_sorted[-1]
            return _CURRENT_THREAD_TAB

        # 3) None exist -> create first run tab
        name = _make_thread_tab_name(1)
        ensure_sheet(name)
        _CURRENT_THREAD_TAB = name
        return name

def next_thread_tab():
    """Return the next sequential run tab name (does not create the sheet)."""
    with _THREAD_TAB_LOCK:
        titles = _all_tab_titles()
        max_idx = 0
        for t in titles:
            idx = _extract_run_index(t)
            if idx is not None and idx > max_idx:
                max_idx = idx
        return _make_thread_tab_name(max_idx + 1)

def get_rows(tab=None):
    tab = tab or latest_thread_tab()
    ss = sheets_service()
    resp = safe_call("read rows", ss.spreadsheets().values().get(
        spreadsheetId=SHEET_ID, range=f'{tab}!A2:D'
    ).execute)
    return resp.get('values', [])

def find_row_index(email, tab=None):
    email = parseaddr(email or "")[1].lower().strip()
    if not email:
        return None
    tab = tab or latest_thread_tab()
    rows = get_rows(tab)
    for idx, row in enumerate(rows, start=2):
        if row and len(row) > 0:
            row_email = parseaddr(row[0] or "")[1].lower().strip()
            if row_email == email:
                return idx
    return None

def add_user(email, thread_id, tab=None):
    email = parseaddr(email)[1].lower().strip()
    tab = tab or latest_thread_tab()
    if not email:
        return False
    log.info(f"[add_user] Writing {email} (thread {thread_id}) to tab {tab}")
    row = [
        email,
        (thread_id or "—"),
        "pending",
        local_dt_str(),   # local-time ISO
    ]
    try:
        append_rows_bulk(tab, [row])   # ✅ now append_rows_bulk is used
        return True
    except Exception as e:
        log.warning(f"[add_user] Failed to append row for {email} in {tab}: {e}")
        return False

def update_status(row_index, status, tab=None):
    tab = tab or latest_thread_tab()
    ss = sheets_service()
    safe_call("update status", ss.spreadsheets().values().update(
        spreadsheetId=SHEET_ID,
        range=f'{tab}!C{row_index}:D{row_index}',
        valueInputOption='RAW',
        body={'values': [[status, local_dt_str()]]}
    ).execute)

def update_thread_id(row_index, thread_id, tab=None):
    tab = tab or latest_thread_tab()
    if not row_index or not thread_id:
        return
    ss = sheets_service()
    safe_call("update threadId", ss.spreadsheets().values().update(
        spreadsheetId=SHEET_ID,
        range=f"{tab}!B{row_index}:B{row_index}",
        valueInputOption="RAW",
        body={"values": [[thread_id]]}
    ).execute)

# ---------------- AI classification ---------------- #
def classify_reply(text: str) -> str:
    """
    Safer heuristic classifier for "completed" vs "pending" using FULL message text with negation handling.
    """
    if not text:
        return "pending"
    lowered = " ".join(str(text).lower().split())
    # Strong pending signals (override completion words)
    PENDING_PHRASES = (
        "not done",
        "not completed",
        "not finished",
        "not resolved",
        "not closed",
        "still pending",
        "in progress",
        "working on it",
        "working on this",
        "not yet",
        "yet to",
        "still open",
        "open issue",
        "will do",
        "will update",
        "tomorrow",
        "next week",
    )
    if any(p in lowered for p in PENDING_PHRASES):
        return "pending"

    # Negation near completion keywords: "not" before "closed/done/finished..."
    COMPLETE_WORDS = ("done", "completed", "finished", "resolved", "closed", "fixed")
    for w in COMPLETE_WORDS:
        if w in lowered:
            idx = lowered.find(w)
            window = lowered[max(0, idx - 12):idx]   # small window before word
            if "not" in window:
                return "pending"

    # Strong completion signals
    COMPLETED_PHRASES = (
        "completed",
        "done",
        "finished",
        "resolved",
        "closed",
        "fixed",
        "issue fixed",
        "task completed",
        "all set",
        "completed successfully",
        "resolved successfully",
    )
    if any(p in lowered for p in COMPLETED_PHRASES):
        return "completed"

    return "pending"

# ---------------- Email processing ---------------- #
def decode_body(payload):
    """Extract best-effort readable body text from a Gmail message payload."""
    import re

    def _b64_to_text(data: str) -> str:
        try:
            return base64.urlsafe_b64decode(data).decode(errors="ignore")
        except Exception:
            return ""

    def _strip_html(html: str) -> str:
        html = re.sub(r"<br\\s*/?>", "\\n", html, flags=re.IGNORECASE)
        html = re.sub(r"</p>", "\\n", html, flags=re.IGNORECASE)
        text = re.sub(r"<[^>]+>", " ", html)
        text = re.sub(r"\\s+", " ", text)
        return text.strip()

    if not payload:
        return ""

    # Multipart
    if "parts" in payload:
        parts = payload.get("parts", []) or []

        # Prefer text/plain
        for part in parts:
            if part.get("mimeType") == "text/plain":
                data = (part.get("body") or {}).get("data")
                if data:
                    return _b64_to_text(data)

        # Fallback to text/html
        for part in parts:
            if part.get("mimeType") == "text/html":
                data = (part.get("body") or {}).get("data")
                if data:
                    return _strip_html(_b64_to_text(data))

        # Nested parts (Gmail sometimes nests)
        for part in parts:
            if part.get("parts"):
                txt = decode_body({"parts": part["parts"]})
                if txt:
                    return txt

    # Single-part
    data = (payload.get("body") or {}).get("data")
    if data:
        return _b64_to_text(data)

    return ""

def extract_recipients(headers: dict) -> list[str]:
    to_str = headers.get("To", "")
    cc_str = headers.get("Cc", "")
    raw = f"{to_str}, {cc_str}"
    addrs = [a.lower().strip() for _, a in getaddresses([raw])]
    alias = (GROUP_EMAIL or "").lower().strip()
    init = (initiator_email() or "").lower().strip()
    return [a for a in addrs if a and a != alias and a != init]

def get_sentlog_threadids_set() -> set[str]:
    """Return a set of threadIds present in SentLog (column E)."""
    try:
        ensure_sent_log_sheet()
        ss = sheets_service()
        resp = safe_call(
            "read sentlog threadIds",
            ss.spreadsheets().values().get(
                spreadsheetId=SHEET_ID,
                range=f"{SENT_LOG_TAB_NAME}!E2:E"
            ).execute,
        )
        values = resp.get("values", []) or []
        out = set()
        for row in values:
            if not row:
                continue
            tid = str(row[0] or "").strip()
            if tid:
                out.add(tid)
        return out
    except Exception as e:
        log.warning(f"[SentLog] failed to read threadIds: {e}")
        return set()
def headers_to_dict(payload):
    return {
        h["name"]: h["value"]
        for h in payload.get("headers", [])
    }

def is_bounce_mail(from_addr, subject):
    return (
        "mailer-daemon" in from_addr
        or "postmaster" in from_addr
        or "delivery status notification" in subject
        or "undelivered" in subject
        or "mail delivery failed" in subject
    )

def process_message(msg_id):
    svc = gmail_service()

    # 1) metadata fetch (cheap)
    raw_meta = svc.users().messages().get(
        userId="me", id=msg_id,
        format="metadata",
        metadataHeaders=["From", "Subject"]
    ).execute()

    thread_id = raw_meta.get("threadId")

    # 2) allow only messages whose threadId exists in SentLog
    if not thread_id or thread_id not in tracked_thread_ids():
        # bridge_log("message_ignored_untracked", msgId=msg_id, threadId=thread_id)

        # Optional: mark as read to avoid scanning forever
        if MARK_UNTRACKED_AS_READ:
            try:
                svc.users().messages().modify(
                    userId="me",
                    id=msg_id,
                    body={"removeLabelIds": ["UNREAD"]}
                ).execute()
            except Exception as e:
                log.warning(f"[process_message] Failed to mark untracked message read: {e}")

        return

    # 3) only now fetch full and process normally
    raw = svc.users().messages().get(
        userId="me", id=msg_id, format="full"
    ).execute()

    headers = {h["name"]: h["value"] for h in raw.get("payload", {}).get("headers", [])}
    sender = headers.get("From")
    sender_email = parseaddr(sender or "")[1]
    subject = headers.get("Subject", "")
    thread_id = raw.get("threadId")

    labels = raw.get("labelIds", []) or []
    me = (initiator_email() or "").strip().lower()

    if "SENT" in labels or (me and sender_email.strip().lower() == me):
        # bridge_log(
        #     "message_skipped_self_sent",
        #     sender=sender_email,
        #     subject=subject,
        #     threadId=thread_id,
        #     labels=labels,
        # )
        return
    # We treat a message as a *new thread* iff it has no "Re:" prefix
    # IMPORTANT: process_message must NOT create new run tabs.
    # New run tabs should be created only when you start a new campaign (send_reminders).
    is_new_thread = not subject.lower().startswith('re:')
    tab = latest_thread_tab()  # will create Run_001 only once if no run tab exists
    bridge_log("message_received", sender=sender_email, subject=subject, threadId=thread_id, newThread=is_new_thread, tab=tab)
    ensure_sheet(tab)

    # Always process reply status update for tracked threads
    row_idx = find_row_index(sender_email, tab)
    if row_idx is None:
        add_user(sender_email, thread_id or "—", tab)
        row_idx = find_row_index(sender_email, tab)
    if thread_id and row_idx:
        update_thread_id(row_idx, thread_id, tab)
    if row_idx:
        full_text = decode_body(raw.get("payload", {}))
        status = classify_reply(full_text or raw.get("snippet", ""))
        update_status(row_idx, status, tab)
        try:
            sync_status_tabs_from_thread(tab)
        except Exception as e:
            log.warning(f"[process_message] sync_status_tabs_from_thread failed: {e}")
        log.info(f"Updated {sender} → {status}")
        bridge_log("reply_processed", sender=sender_email, threadId=thread_id, status=status, tab=tab)

    # mark as read
    svc.users().messages().modify(
        userId='me', id=msg_id, body={"removeLabelIds": ["UNREAD"]}
    ).execute()

def track_email_threads():
    try:
        global creds
        if not creds:
        # try lazy reload from token (supports pickle or JSON)
            for path in (SECRET_TOKEN_FILE, FALLBACK_TOKEN_FILE):
                c = _load_creds_from_path(path)
                if c:
                    creds = c
                    break
        if not creds:
            return
        if isCreditsExpired:
            log.warning("Gmail credentials have expired; skipping poll.")
            return
        svc = gmail_service()
        # init = (initiator_email() or "").strip()
        query = "in:sent newer_than:10m from:me"
        resp = svc.users().messages().list(
            userId="me",
            q=query,
            maxResults=1000
        ).execute()
        if len(resp.get('messages', [])) == 0:
            return
        thread_id_list = get_sentlog_threadid_of_day_set()
        for m in resp.get('messages', []):
            if(m['threadId'] in thread_id_list):
                check_bounced_emails(m['threadId'])

    except Exception as e:
        log.warning(f"[track_email_threads] Failed to list messages: {e}")
        return

def ensure_sheet_exists(sheet_name):
    ss = sheets_service()

    meta = safe_call("get spreadsheet meta", ss.spreadsheets().get(spreadsheetId=SHEET_ID).execute)

    existing_sheets = [s["properties"]["title"] for s in meta.get("sheets", [])]

    if sheet_name not in existing_sheets:
        safe_call("addSheet", ss.spreadsheets().batchUpdate(
            spreadsheetId=SHEET_ID,
            body={"requests": [{"addSheet": {"properties": {"title": sheet_name}}}]}
        ).execute)
        safe_call("write sent log header", ss.spreadsheets().values().update(
            spreadsheetId=SHEET_ID,
            range=f"{sheet_name}!A1",
            valueInputOption="RAW",
            body={"values": [STATUS_LOG_HEADER]}
        ).execute)
        bridge_log("sheet_created", tab=sheet_name)

def append_to_sheet(sheet_name, row_data):
    ss = sheets_service()

    safe_call("append sent log", ss.spreadsheets().values().append(
            spreadsheetId=SHEET_ID,
            range=f"{sheet_name}!A1",
            valueInputOption="RAW",
            insertDataOption="INSERT_ROWS",
            body={
            "values": [row_data]
            }
        ).execute)

def extract_bounce_reason(payload):

    def decode(data):
        return base64.urlsafe_b64decode(data).decode("utf-8", errors="ignore")

    for part in payload.get("parts", []):

        # Look inside nested parts
        if part.get("parts"):
            for subpart in part["parts"]:
                if subpart.get("parts"):
                    for inner in subpart["parts"]:
                        if inner.get("mimeType") == "text/plain":
                            data = inner.get("body", {}).get("data")
                            if data:
                                text = decode(data)

                                # Extract main explanation paragraph
                                lines = text.splitlines()

                                clean_lines = []
                                for line in lines:
                                    if line.strip() and not line.startswith("The response from"):
                                        clean_lines.append(line.strip())

                                message = " ".join(clean_lines)

                                # Remove extra spaces
                                message = re.sub(r"\s+", " ", message)

                                return message.strip()

    return "Email delivery failed."       

def simplify_bounce_reason(raw_text):
    if not raw_text:
        return "Email delivery failed."

    text = raw_text.lower()

    # Most common hard bounces
    if "address not found" in text:
        return "The email address does not exist."

    if "user unknown" in text:
        return "The recipient email address is not recognized."

    if "mailbox unavailable" in text:
        return "The recipient's mailbox is unavailable."

    if "no such user" in text:
        return "The email address does not exist."

    if "invalid recipient" in text:
        return "The email address is invalid."

    # Mailbox problems
    if "quota exceeded" in text:
        return "The recipient's mailbox is full."

    if "mailbox full" in text:
        return "The recipient's mailbox is full."

    # Domain problems
    if "domain not found" in text:
        return "The recipient domain does not exist."

    if "dns" in text and "failed" in text:
        return "The recipient domain could not be reached."

    # Spam / rejection
    if "spam" in text:
        return "The message was rejected as spam."

    if "blocked" in text:
        return "The recipient server blocked the message."

    if "rejected" in text:
        return "The recipient server rejected the message."

    # Generic fallback
    return "Email delivery failed due to server rejection."

def get_mail_status_set(sheet_name) -> set[str]:
    """Return a set of normalized recipient emails present in SentLog (column B)."""
    try:
        # ensure_sheet_exists(sheet_name)
        ss = sheets_service()
        resp = safe_call(
            "read status",
            ss.spreadsheets().values().get(
                spreadsheetId=SHEET_ID,
                range=f"{sheet_name}!A2:E"
            ).execute,
        )
        values = resp.get("values", []) or []
        return values
    except Exception as e:
        log.warning(f"[SentLog] failed to read recipients: {e}")
        return set()

def already_logged_in_last_24_hours(sheet_name, msg_id):
    rows = get_mail_status_set(sheet_name)  # you must already have this
    if not rows:
        return False
    now = datetime.utcnow()
    cutoff = int(time.time()) - EMAIL_WINDOW_SECONDS 

    for row in rows:
        try:
            logged_time = datetime.fromisoformat(row[0])
            logged_time_unix = int(logged_time.timestamp())
            existing_msg_id = row[3]

            if existing_msg_id == msg_id:
                return True
        except Exception:
            continue
    return False

def check_bounced_emails(msg_id):
    svc = gmail_service()
    raw_meta = svc.users().messages().get(
        userId="me", id=msg_id,
        format="metadata",
        metadataHeaders=["To", "Subject", "From"]
    ).execute()
    thread = svc.users().threads().get(
        userId="me",
        id=msg_id,
        format="full",
        metadataHeaders=["From", "To", "Subject", "Message-ID"]
    ).execute()
    bounce = False 
    original_to = ""
    from_addr = ""

    for msg in thread.get("messages", []):
        payload = msg.get("payload", {})
        headers = headers_to_dict(msg.get("payload", {}))
        from_address = headers.get("From", "").lower()
        address = headers.get("To", "")
        subject = headers.get("Subject", "")
        message_id = headers.get("Message-ID", "")

        # Capture your original sent mail
        if not original_to and "mailer-daemon" not in from_address:
            from_addr = from_address
            to_addr = address
            original_to = to_addr
            original_subject = subject
            original_message_id = message_id

        # Check bounce
        if is_bounce_mail(from_address, subject):
            bounce = True
            raw_reason = extract_bounce_reason(payload)
            bounce_reason = simplify_bounce_reason(raw_reason)
            break
        
    try:
        headers = headers_to_dict(raw_meta["payload"])
    except Exception as e:
        return

    from_addr = headers.get("From", "").lower()
    to_addr = headers.get("To", "").lower()
    subject = headers.get("Subject", "").lower()
    message_id = headers.get("Message-ID", "")
    if bounce:
        sheet_name = FAILED_MAIL_TAB_NAME
    else:
        sheet_name = SUCCESS_MAIL_TAB_NAME

    ensure_sheet_exists(sheet_name)

    row = [
        iso_now_local(),
        to_addr,
        subject,
        msg_id,
        # message_id,
        "BOUNCED" if bounce else "SUCCESS",
        bounce_reason if bounce else ""
    ]
    if not already_logged_in_last_24_hours(sheet_name, msg_id):
        append_to_sheet(sheet_name, row)
    else:
        print("Already logged in last 24 hours. Skipping.")

    # IMPORTANT: remove old 'thread_id = raw.get("threadId")' since thread_id already set

def poll_group_mail():
    global creds
    if not creds:
        # try lazy reload from token (supports pickle or JSON)
        for path in (SECRET_TOKEN_FILE, FALLBACK_TOKEN_FILE):
            c = _load_creds_from_path(path)
            if c:
                creds = c
                break
    if not creds:
        return
    if isCreditsExpired:
        log.warning("Gmail credentials have expired; skipping poll.")
        return
    svc = gmail_service()
    init = (initiator_email() or "").strip()
    if init:
        query = f'is:unread (to:{GROUP_EMAIL} OR to:{init}) -from:me -in:sent'
    else:
        query = f'to:{GROUP_EMAIL} is:unread -from:me -in:sent'
    resp = svc.users().messages().list(userId='me', q=query, maxResults=20).execute()
    count = len(resp.get('messages', [])) if resp.get('messages') else 0
    # bridge_log("poll_group_mail", pending=count)
    for m in resp.get('messages', []):
        process_message(m['id'])

# ---------------- Reminders ---------------- #
REMINDER_SUBJECT = "Gentle reminder – awaiting your update"
REMINDER_BODY = (
    """
Hi there,\n\n We haven't received a 'completed' update from you yet. Please reply to the previous e‑mail with your current status at your earliest convenience.\n\nThanks!
    """
)

def _strip_html_to_text(html: str) -> str:
    # minimal conversion: <br> / </p> => newline, then strip tags
    txt = re.sub(r"<br\\s*/?>", "\\n", html, flags=re.IGNORECASE)
    txt = re.sub(r"</p\\s*>", "\\n", txt, flags=re.IGNORECASE)
    txt = re.sub(r"<[^>]+>", "", txt)
    return "\\n".join([ln.rstrip() for ln in txt.splitlines()]).strip()

# ---------------- Gmail sender (single recipient) ---------------- #

def _send_email_raw(recipient: str, subject: str, body: str, unsubscribe_url: str = None):
    """
    Smart domain-aware email sender.

    - COMMON DOMAIN (@gmail.com, @yahoo.com, etc.):
        No custom SPF/DKIM/DMARC possible. Plain-text only, minimal safe
        RFC-5322 headers. NO List-Unsubscribe (bulk header raises flags on
        personal accounts).

    - CUSTOM / WORKSPACE DOMAIN (@yourcompany.com etc.):
        Full RFC-5322 headers (From, Message-ID, Date, Reply-To),
        List-Unsubscribe (RFC 8058), and dual MIME (plain + HTML).
    """
    if isCreditsExpired:
        return None
    recipient = (recipient or "").strip()
    if not recipient:
        raise ValueError("recipient is empty")

    init = (initiator_email() or "").strip()
    sender_is_common = is_common_domain(init) if init else True
    domain_type = 'common' if sender_is_common else 'custom'

    msg = EmailMessage()
    msg["To"]      = recipient
    msg["Subject"] = subject or "Reminder"

    if sender_is_common:
        # ── COMMON DOMAIN STRATEGY ──────────────────────────────────────────
        # Gmail/Yahoo/etc.: cannot set DNS records. Focus on:
        #   • Explicit From header (prevents "anonymous sender" flag)
        #   • Unique Message-ID and Date (RFC 5322 compliance)
        #   • Plain-text only (harder to fingerprint as templated bulk mail)
        #   • NO List-Unsubscribe (adding bulk headers on personal account raises spam score)
        if init:
            msg["From"]     = init
            msg["Reply-To"] = init
        msg["Date"]       = formatdate(localtime=True)
        msg["Message-ID"] = f"<{uuid.uuid4()}@gmail-agent.local>"
        msg["X-Mailer"]   = 'Cosmitude Email Tracker/1.0'
        body_in = body or ""
        # Strip HTML to plain text for common domain sends
        msg.set_content(_strip_html_to_text(body_in) if ("<" in body_in and ">" in body_in) else body_in)
        log.info(f"[send_email] common-domain send from={init} to={recipient}")
    else:
        # ── CUSTOM / WORKSPACE DOMAIN STRATEGY ─────────────────────────────
        # Full RFC-5322 + deliverability headers — SPF/DKIM/DMARC can be
        # configured on the sender's custom domain.
        if init:
            msg["From"]     = init
            msg["Reply-To"] = init
        msg["Date"]       = formatdate(localtime=True)
        msg["Message-ID"] = f"<{uuid.uuid4()}@cosmitude.com>"
        msg["X-Mailer"]   = 'Cosmitude Email Tracker/1.0'
        # List-Unsubscribe — mandatory for bulk senders (Google policy Feb 2024)
        if unsubscribe_url:
            msg["List-Unsubscribe"]      = f"<{unsubscribe_url}>"
            msg["List-Unsubscribe-Post"] = "List-Unsubscribe=One-Click"
        body_in = body or ""
        if "<" in body_in and ">" in body_in:
            msg.set_content(_strip_html_to_text(body_in))  # text/plain
            msg.add_alternative(body_in, subtype="html")   # text/html
        else:
            plain_body = body_in
            html_body = f"""<!DOCTYPE html>
<html lang="en">
<body style="font-family:Arial,sans-serif;color:#333;line-height:1.6;max-width:600px;margin:0 auto;padding:20px;">
  <p>{plain_body.replace(chr(10), '<br>')}</p>
  <br>
  <hr style="border:none;border-top:1px solid #eee;margin:20px 0;">
  <p style="font-size:12px;color:#999;text-align:center;">
    This email was sent by <strong>Cosmitude Email Tracker</strong>.<br>
    {"If you no longer wish to receive these emails, <a href='" + unsubscribe_url + "' style='color:#999'>click here to unsubscribe</a>." if unsubscribe_url else ""}
  </p>
</body></html>"""
            msg.set_content(plain_body)
            msg.add_alternative(html_body, subtype="html")
        log.info(f"[send_email] custom-domain send from={init} to={recipient}")

    raw = base64.urlsafe_b64encode(msg.as_bytes()).decode("utf-8")
    svc = gmail_service()
    try:
        resp = svc.users().messages().send(userId="me", body={"raw": raw}).execute()
    except Exception as e:
        log.warning(f"[send_email] Failed to send email to {recipient}: {e}")
        if hasattr(e, 'status_code') and e.status_code == 400:
            append_sent_log(recipient, msg["Subject"], "", "", result="", error=getattr(e, 'reason', str(e)))
            return getattr(e, 'status_code', None)
        return None

    msg_id = resp.get("id", "") if isinstance(resp, dict) else ""
    thr_id = resp.get("threadId", "") if isinstance(resp, dict) else ""
    log.info(f"[add_user] Sending email to {recipient} (thread {thr_id})")
    mailData = {
        "recipient": recipient,
        "subject": msg["Subject"],
        "msg_id": msg_id,
        "thread_id": thr_id,
        "result": "sent",
        "domain_type": domain_type,
    }
    bridge_log("email_sent", level="info", **mailData)
    _mark_as_sent_in_memory(recipient, msg["Subject"])
    append_sent_log(recipient, msg["Subject"], msg_id, thr_id, result="sent", error="")
    return resp

def roster_recipients() -> list[str]:
    main_tab = detect_main_tab_name()
    emails = get_emails_from_tab(main_tab) if main_tab else []
    alias = (GROUP_EMAIL or "").lower().strip()
    out, seen = [], set()
    for e in emails:
        ne = _normalize_email(e)
        if ne and ne != alias and ne not in seen:
            out.append(ne); seen.add(ne)
    return out

def start_group_thread(subject: Optional[str] = None, body: Optional[str] = None,force_new_run: bool = False):
    """
    Proactively send a new email to the Google Group to start a fresh thread.
    A new timestamp tab is created first. Since we won't know the Gmail threadId
    at this moment, we seed the new tab with placeholder thread id '—'.
    """
    if not creds:
        # bridge_log("start_thread_skipped", level="warn", reason="no_creds")
        return {"status": "skipped", "reason": "not_authenticated"}

    if isCreditsExpired:
        # bridge_log("start_thread_skipped", level="warn", reason="credits_expired")
        return {"status": "skipped", "reason": "credits_expired"}
    with _THREAD_TAB_LOCK:
        if SINGLE_THREAD_TAB:
            tab = fixed_thread_tab_name()
        else:
            tab = next_thread_tab() if force_new_run else latest_thread_tab()
    _CURRENT_THREAD_TAB = tab
    ensure_sheet(tab)
    try:
        ensure_and_sync_thread_tab(tab)
        sync_status_tabs_from_thread(tab)
    except Exception:
        pass

    roster = roster_recipients()   # your existing roster list
    subject = MAIN_EMAIL_SUBJECT
    body = MAIN_EMAIL_BODY

    subj_key = (subject or "").strip().lower()
    sent_recent = sent_pairs_recent(within_seconds=EMAIL_WINDOW_SECONDS)

    # Filter out recently sent and unsubscribed recipients; compute unsubscribe URL for custom domains
    _st_from_addr = initiator_email()
    _st_sender_is_common = is_common_domain(_st_from_addr) if _st_from_addr else True
    to_send = [e for e in roster if (_normalize_email(e), subj_key) not in sent_recent and _normalize_email(e) not in _unsubscribed]

    if not to_send:
        return

    _st_unsub_url = None if _st_sender_is_common else UNSUBSCRIBE_BASE_URL
    result = send_email(to_send, subject, body, unsubscribe_url=_st_unsub_url)
    bridge_log("thread_kickoff_sent", subject=subject, tab=tab)
    return {"status": "sent", "tab": tab, "subject": subject}

def check_and_start_thread_if_missing(subject: Optional[str] = None, body: Optional[str] = None):
    """If no timestamp-like thread tab exists yet, proactively start a new group thread."""
    try:
        titles = _all_tab_titles()
    except Exception as e:
        log.warning(f"[check_and_start_thread_if_missing] Failed to read tab titles: {e}")
        titles = []

    has_thread_tab = any(_is_thread_tab(t) for t in titles)
    if has_thread_tab:
        return {"status": "exists"}

    return start_group_thread(subject, body)

def send_reminders(subject: str | None = None, body: str | None = None):
    """
    One unified notifier.
    For the latest thread tab, if a row's Status is anything other than
    "completed", send a reminder e-mail — respecting unsubscribe list
    and applying domain-aware inter-send delays.
    """
    if not creds:
        return
    if isCreditsExpired:
        log.warning("Gmail credentials have expired; skipping reminders.")
        return

    # Determine sender domain type once for the whole batch
    from_addr = initiator_email()
    sender_is_common = is_common_domain(from_addr) if from_addr else True

    # Always operate on the newest thread tab
    tab = latest_thread_tab()
    try:
        sync_status_tabs_from_thread(tab)
    except Exception:
        pass
    ensure_and_sync_thread_tab(tab)
    tab = latest_thread_tab()

    targets: set[str] = set()
    rows = get_rows(PENDING_TAB_NAME)
    targets = {row[0].strip().lower() for row in rows if row and row[0]}
    for row in rows:
        email = row[0] if row else ""
        status = row[2].strip().lower() if len(row) >= 3 else ""
        if not email:
            continue
        # Skip anyone who unsubscribed
        if email.lower().strip() in _unsubscribed:
            log.info(f"[reminder] {email} is unsubscribed — skipping.")
            continue
        if status != "completed":
            targets.add(email)

    bridge_log("reminder_targets", count=len(targets), tab=tab,
               targets=list(targets), domain_type='common' if sender_is_common else 'custom')
    if not targets:
        log.info("[reminder] No users to notify.")
        return

    subject = subject or REMINDER_SUBJECT
    body    = body    or REMINDER_BODY
    for email in targets:
        # Build unsubscribe URL only for custom domains
        unsubscribe_url = f"{UNSUBSCRIBE_BASE_URL}?email={email}" if not sender_is_common else None
        log.info(f"[reminder] Notifying {email}")
        bridge_log("reminder_sending", recipient=email, tab=tab)
        send_email(email, subject, body, unsubscribe_url=unsubscribe_url)

        # Inter-send delay:
        #   common domain  → 30–90 s  (mimic human cadence, avoid burst detection)
        #   custom domain  → 15–30 s  (still randomised to avoid fixed-interval detection)
        if sender_is_common:
            delay = random.randint(30, 90)
        else:
            delay = random.randint(15, 30)
        log.info(f"[reminder] Waiting {delay}s before next send.")
        time.sleep(delay)

def prepare_run_state() -> str:
    """Prepare current run before sending (used by API-triggered send_reminders).

    - Ensures current run tab exists
    - Syncs run tab from Main roster (adds missing emails)
    - Rebuilds Pending/Completed based on run tab
    """
    ensure_status_tabs()
    ensure_sent_log_sheet()

    tab = latest_thread_tab()
    ensure_sheet(tab)

    try:
        ensure_and_sync_thread_tab(tab)
    except Exception as e:
        log.warning(f"[prepare_run_state] ensure_and_sync_thread_tab failed: {e}")

    try:
        sync_status_tabs_from_thread(tab)
    except Exception as e:
        log.warning(f"[prepare_run_state] refresh_status_tabs_from_thread failed: {e}")

    return tab

# ---------------- FastAPI setup ---------------- #
app = FastAPI(title="Gmail Group Monitor")

# --- CORS setup for React frontend ---
from fastapi.middleware.cors import CORSMiddleware

# Allow override via env: ALLOWED_ORIGINS="https://cosmitude.com,https://www.cosmitude.com,http://localhost:8080"
_env_origins = [o.strip() for o in (os.getenv("ALLOWED_ORIGINS") or "").split(",") if o.strip()]
origins = _env_origins or [
    "http://localhost:3000",
    "http://127.0.0.1:3000",
    "http://localhost:8080",
    "http://127.0.0.1:8080",
    "http://localhost:5173",
    "http://127.0.0.1:5173",
    "http://localhost:4200",
    "http://127.0.0.1:4200",
    "https://cosmitude.com",
    "https://www.cosmitude.com",
    "https://deployment.cosmitude.com",
    "http://34.180.57.64:8000",
    "http://34.180.9.224:80",
    "https://testing.cosmitude.com"
]

app.add_middleware(
    CORSMiddleware,
    allow_origins=origins,
    allow_credentials=True,
    allow_methods=["*"],
    allow_headers=["*"],
)
@app.get("/")
def root():
    return {"status": "ok"}

@app.get("/healthz")
def healthz():
    return {"status":"ok"}

def get_dynamic_redirect_uri(request: Request) -> str:
    xf_proto = request.headers.get("x-forwarded-proto")
    xf_host = request.headers.get("x-forwarded-host")
    if xf_host and xf_proto:
        base = f"{xf_proto}://{xf_host}".rstrip("/")
    else:
        host = request.headers.get("host")
        if host:
            base = f"{request.url.scheme}://{host}".rstrip("/")
        else:
            base = str(request.base_url).rstrip("/")
            
    if os.getenv("FORCE_PUBLIC_HTTPS", "true").lower() == "true":
        from urllib.parse import urlparse, urlunparse
        u = urlparse(base)
        if (u.hostname or "").endswith("cosmitude.com") and u.scheme == "http":
            u = u._replace(scheme="https")
            base = urlunparse(u)
            
    return f"{base}/oauth2callback"

def _auth_handler(code: Optional[str], state: Optional[str], error: Optional[str], dynamic_redirect_uri: Optional[str] = None):
    """
    Core OAuth logic extracted so we can call it from HTTP routes *and* internally
    without tripping over FastAPI's Query() defaults when called as a normal function.
    """
    global creds

    if error:
        # Bubble up OAuth errors (e.g., user denied consent)
        # bridge_log("oauth_error", level="error", error=str(error), state=state)
        raise HTTPException(400, f"OAuth error: {error}")

    if not os.path.exists(CREDENTIALS_FILE):
        log.error(f"Google OAuth client secrets not found at {CREDENTIALS_FILE}")
        raise HTTPException(500, f"credentials.json not found at {CREDENTIALS_FILE}")

    r_uri = dynamic_redirect_uri if dynamic_redirect_uri else REDIRECT_URI
    try:
        flow = Flow.from_client_secrets_file(
            CREDENTIALS_FILE,
            scopes=SCOPES,
            redirect_uri=r_uri
        )
    except Exception as e:
        log.error("Failed to create OAuth Flow from client secrets", exc_info=True)
        raise HTTPException(500, f"oauth flow init error: {e}")

    if code:
        try:
            # Retrieve cached PKCE code verifier if it exists
            verifier_file = "/tmp/oauth_verifier.txt"
            if os.path.exists(verifier_file):
                with open(verifier_file, "r") as vf:
                    flow.code_verifier = vf.read().strip()
                try:
                    os.remove(verifier_file)
                except Exception as e:
                    log.warning(f"Could not remove verifier config: {e}")
                    pass

            flow.fetch_token(code=code)
            # Sanity check to ensure credentials object was created
            if not getattr(flow, "credentials", None):
                raise HTTPException(400, "OAuth exchange did not return credentials")
        except Exception as e:
            log.error("Failed to fetch token during /auth exchange", exc_info=True)
            raise HTTPException(400, f"Failed to fetch token with provided code: {e}")
        
        creds_local = flow.credentials
        try:
            _safe_write_token(creds_local)
        except Exception:
            log.warning("Failed to persist token after fetch; continuing without writing.")
        log.info(f"[OAuth] Stored token at {_get_write_token_path()}")
        creds = creds_local
        log.info("[OAuth] Credentials obtained; scopes: %s", creds.scopes)

        # Post-auth setup in background to avoid blocking or OOM during OAuth exchange
        def _post_auth_setup_safe():
            try:
                tab = fixed_thread_tab_name() if SINGLE_THREAD_TAB else latest_thread_tab()
                ensure_sheet(tab)
                group_members = get_group_members()
                if group_members:
                    try:
                        existing_in_tab = _get_tab_emails_set(tab)
                    except Exception:
                        existing_in_tab = set()
                    to_add = []
                    for email in group_members:
                        ne = _normalize_email(email)
                        if ne and ne not in existing_in_tab:
                            to_add.append([ne, '—', 'pending', local_dt_str()])
                            existing_in_tab.add(ne)
                    if to_add:
                        append_rows_bulk(tab, to_add)
                log.info("[OAuth] Post-auth setup completed")
            except Exception as e:
                log.warning(f"Post-auth sheet setup failed (non-fatal): {e}")
        Thread(target=_post_auth_setup_safe, daemon=True).start()
        log.info("[OAuth] Post-auth setup started in background")

        # bridge_log("oauth_success", scopes=getattr(creds, "scopes", []))
        return {"status": "authenticated"}
    else:
        try:
            # request 'offline' to obtain a refresh token; include granted scopes to avoid prompting unnecessarily
            auth_url, _state = flow.authorization_url(
                prompt="consent",
                access_type="offline",
                include_granted_scopes="true"
            )
            # Cache PKCE code verifier
            if hasattr(flow, "code_verifier") and flow.code_verifier:
                with open("/tmp/oauth_verifier.txt", "w") as vf:
                    vf.write(flow.code_verifier)
        except Exception as e:
            log.error("Failed to build authorization URL", exc_info=True)
            raise HTTPException(500, f"authorization_url error: {e}")
        # bridge_log("oauth_url_issued")
        return {
            "status": "needs_code",
            "message": "Visit the URL in a browser, authorize, and copy the code parameter from the redirected URL, then call this endpoint again with ?code=THE_CODE",
            "url": auth_url,
            "redirect_uri": REDIRECT_URI,
        }

@app.get("/auth")
def auth(request: Request,
         code: Optional[str] = Query(default=None, description="Authorization code from user"),
         state: Optional[str] = Query(default=None),
         error: Optional[str] = Query(default=None)):
    dyn_uri = get_dynamic_redirect_uri(request)
    return _auth_handler(code, state, error, dyn_uri)

# Provide a direct callback endpoint for OAuth2 redirect_uri
@app.api_route("/oauth2callback", methods=["GET", "HEAD"])
def oauth2callback(request: Request,
                   code: Optional[str] = Query(default=None),
                   state: Optional[str] = Query(default=None),
                   error: Optional[str] = Query(default=None)):
    """
    Optional direct callback endpoint. If the redirect_uri is pointed at the agent itself
    (e.g., via the CloudRunner proxy /agent/{id}/proxy/oauth2callback), complete the exchange here.
    """
    if request.method == "HEAD":
        return Response(status_code=204)
    if error:
        # bridge_log("oauth_error", level="error", error=error, state=state)
        raise HTTPException(400, f"OAuth error: {error}")
    if not code:
        raise HTTPException(400, "Missing 'code' in callback")
    # Reuse the main handler to perform the exchange and setup
    dyn_uri = get_dynamic_redirect_uri(request)
    return _auth_handler(code, state, None, dyn_uri)

# Add POST helper endpoint for code exchange
from pydantic import BaseModel

class UpdateSheetLink(BaseModel):
    url: str

class UpdateGroupEmail(BaseModel):
    email: str

class ReminderConfig(BaseModel):
    subject: str
    body: str

class ReminderPayload(BaseModel):
    subject: Optional[str] = None
    body: Optional[str] = None

class BlockedDomainRequest(BaseModel):
    blocked_domains: List[str]

class DailyEmailLimitRequest(BaseModel):
    limit: int

@app.post("/auth/code")
async def auth_code(request: Request):
    """Accept OAuth code via JSON, form, or query string for robustness."""
    code_val = None
    try:
        ctype = request.headers.get("content-type", "")
        if "application/json" in ctype:
            body = await request.json()
            if isinstance(body, dict):
                code_val = body.get("code")
        elif "application/x-www-form-urlencoded" in ctype:
            form = await request.form()
            code_val = form.get("code")
    except Exception as e:
        log.warning(f"/auth/code parse error: {e}")
    if not code_val:
        code_val = request.query_params.get("code")
    if not code_val:
        raise HTTPException(400, "Missing 'code'")
    dyn_uri = get_dynamic_redirect_uri(request)
    return _auth_handler(code_val, None, None, dyn_uri)


# --- Auth status & config endpoints ---
@app.get("/auth/status")
def auth_status():
    """Return whether the agent is authenticated with Google APIs.
    Also returns sender domain type (common vs custom) so the frontend
    can warn users using personal gmail accounts.
    """
    global creds
    try:
        if creds is None:
            for path in (SECRET_TOKEN_FILE, FALLBACK_TOKEN_FILE):
                try:
                    if os.path.exists(path):
                        creds_local = _load_creds_from_path(path)
                        if creds_local:
                            creds = creds_local
                            break
                except Exception as e:
                    log.warning(f"[auth_status] Failed loading creds from {path}: {e}")
        try:
            if creds and getattr(creds, "expired", False) and getattr(creds, "refresh_token", None):
                creds.refresh(GoogleRequest())
                _safe_write_token(creds)
        except Exception as e:
            log.warning(f"[auth_status] Refresh failed: {e}")
        status = "authenticated" if (creds and getattr(creds, "valid", False)) else "needs_auth"
        scopes = list(getattr(creds, "scopes", []) or [])
        # Determine sender domain type for frontend warnings
        sender_email   = ""
        domain_type    = "unknown"
        domain_warning = None
        if status == "authenticated":
            try:
                sender_email = initiator_email()
                if sender_email:
                    if is_common_domain(sender_email):
                        domain_type    = "common"
                        domain_warning = (
                            f"You are using a personal email account ({sender_email}). "
                            "SPF/DKIM/DMARC cannot be configured for this domain, which "
                            "reduces email deliverability. For best results, connect a "
                            "Google Workspace account with a custom domain."
                        )
                    else:
                        domain_type = "custom"
            except Exception as e:
                log.warning(f"[auth_status] Could not resolve sender profile: {e}")
        return {
            "status":         status,
            "scopes":         scopes,
            "redirect_uri":   REDIRECT_URI,
            "sender_email":   sender_email,
            "domain_type":    domain_type,
            "domain_warning": domain_warning,
        }
    except Exception as e:
        log.warning(f"[auth_status] Unexpected error: {e}")

# --- Unsubscribe endpoints (RFC 8058 / Google Feb 2024 mandate) ---------------

@app.get("/unsubscribe")
def unsubscribe(email: str = Query(..., description="Email address to unsubscribe")):
    """One-click unsubscribe via GET (linked from email footer)."""
    clean = email.lower().strip()
    _unsubscribed.add(clean)
    bridge_log("unsubscribe", email=clean)
    log.info(f"[unsubscribe] {clean} opted out.")
    return Response(
        content=f"""<!DOCTYPE html><html><body
          style="font-family:Arial,sans-serif;text-align:center;padding:60px;color:#333">
          <h2>&#x2705; Unsubscribed</h2>
          <p><strong>{clean}</strong> has been removed from future reminder emails.</p>
          <p style="color:#999;font-size:13px;">You can close this window.</p>
        </body></html>""",
        media_type="text/html"
    )

@app.post("/unsubscribe")
async def unsubscribe_post(request: Request):
    """POST one-click unsubscribe as required by List-Unsubscribe-Post header (RFC 8058)."""
    email_val = request.query_params.get("email", "")
    if not email_val:
        try:
            form = await request.form()
            email_val = form.get("email", "")
        except Exception:
            pass
    if not email_val:
        try:
            body_json = await request.json()
            email_val = body_json.get("email", "")
        except Exception:
            pass
    clean = email_val.lower().strip() if email_val else ""
    if clean:
        _unsubscribed.add(clean)
        bridge_log("unsubscribe_post", email=clean)
        log.info(f"[unsubscribe] POST opt-out: {clean}")
    return {"status": "unsubscribed", "email": clean}

@app.get("/unsubscribed/list")
def list_unsubscribed():
    """Admin endpoint — view all opt-out addresses for this agent session."""
    return {"unsubscribed": sorted(_unsubscribed), "count": len(_unsubscribed)}

@app.get("/debug/oauth")
def debug_oauth():
    return {
        "redirect_uri": REDIRECT_URI,
        "credentials_file": CREDENTIALS_FILE,
        "credentials_file_exists": os.path.exists(CREDENTIALS_FILE),
        "token_secret_path": SECRET_TOKEN_FILE,
        "token_fallback_path": FALLBACK_TOKEN_FILE,
        "token_exists_secret": os.path.exists(SECRET_TOKEN_FILE),
        "token_exists_fallback": os.path.exists(FALLBACK_TOKEN_FILE),
    }

@app.get("/config/sheet")
def get_sheet_config():
    """Return current Google Sheet configuration (URL + derived ID)."""
    return {"sheet_url": SHEET_URL, "sheet_id": SHEET_ID}

@app.post("/config/sheet")
def set_sheet_config(link: UpdateSheetLink):
    """Update the Google Sheet URL/ID used by the agent at runtime."""
    global SHEET_URL, SHEET_ID
    SHEET_URL = link.url
    SHEET_ID = _sheet_id_from_url(SHEET_URL)
    # Best-effort: verify we can see or create the latest thread tab if already authenticated
    verified = False
    try:
        ensure_sheet(latest_thread_tab())
        verified = True
    except Exception as e:
        log.warning(f"[set_sheet_config] ensure_sheet failed (may be unauth'd yet): {e}")
    bridge_log("sheet_config_updated", sheet_url=SHEET_URL, sheet_id=SHEET_ID, verified=verified)
    return {"status": "ok", "sheet_url": SHEET_URL, "sheet_id": SHEET_ID, "verified": verified}

# --- Google Group config endpoints ---
@app.get("/config/group")
def get_group_config():
    """Return current Google Group e-mail used for tracking."""
    return {"group_email": GROUP_EMAIL}

@app.post("/config/group")
def set_group_config(body: UpdateGroupEmail):
    """Update Google Group e-mail used for tracking."""
    global GROUP_EMAIL
    GROUP_EMAIL = body.email
    bridge_log("group_email_updated", group_email=GROUP_EMAIL)
    return {"status": "ok", "group_email": GROUP_EMAIL}

# --- Reminder config endpoints ---
@app.get("/config/reminder")
def get_reminder_config():
    """Return current default reminder subject/body."""
    return {"subject": REMINDER_SUBJECT, "body": REMINDER_BODY}

@app.post("/config/reminder")
def set_reminder_config(cfg: ReminderConfig, background_tasks: BackgroundTasks):
    global REMINDER_SUBJECT, REMINDER_BODY
    REMINDER_SUBJECT = cfg.subject
    REMINDER_BODY = cfg.body

    background_tasks.add_task(
        bridge_log,
        "reminder_config_updated",
        subject=cfg.subject,
        body_len=(len(cfg.body) if cfg.body else 0),
    )
    return {"status": "ok"}

@app.post("/config/updateDailyEmailLimit")
def update_daily_email_limit(req: DailyEmailLimitRequest):
    if not req.limit:
        return {"status": "No Limit Found"}
    update_email_limit(req.limit)
    return {"status": "ok"}

@app.get("/config/getDailyEmailLimit")
def get_daily_email_limit():
    limit = _load_email_limit_file()
    bridge_log("daily_email_limit_fetched", emailLimits=limit)
    return limit

@app.post("/config/updateBlockedDomain")
def update_blocked_domain_list(req: BlockedDomainRequest):
    if not req.blocked_domains:
        return {"status": "No Data Found"}

    update_email_policy(req.blocked_domains)
    return {"status": "ok"}

@app.get("/config/getBlockedDomain")
def get_blocked_Domain_List():
    blocked_Domain_Data = _load_email_policy_file()
    bridge_log("blocked_domain_fetched", blockedDomains=blocked_Domain_Data)
    return blocked_Domain_Data

@app.get("/manual/poll")
def manual_poll():
    bridge_log("manual_poll_triggered")
    poll_group_mail()
    return {"status": "polled"}

@app.get("/manual/remind")
def manual_remind():
    run_id = str(uuid.uuid4())
    Thread(target=_run_remind_job, args=(run_id, None, None, True, False), daemon=True).start()
    bridge_log("manual_remind_accepted", run_id=run_id)
    return {"status": "ok", "mode": "thread", "run_id": run_id}


@app.post("/manual/remind")
def manual_remind_post(payload: ReminderPayload):
    run_id = str(uuid.uuid4())
    Thread(target=_run_remind_job, args=(run_id, payload.subject, payload.body, True, False), daemon=True).start()
    try:
        bridge_log(
            "manual_remind_accepted",
            run_id=run_id,
            subject=payload.subject,
            body_preview=(payload.body[:80] if payload.body else None),
        )
    except Exception:
        pass

    return {"status": "ok", "mode": "background", "run_id": run_id}


# In-memory job state (optional but useful for UI polling)
_JOB_STATE: Dict[str, Dict[str, Any]] = {}
_JOB_TTL_SECONDS = 3600  # 1 hour

def _now_epoch() -> int:
    return int(time.time())

def _job_set(run_id: str, **fields):
    st = _JOB_STATE.get(run_id, {})
    st.update(fields)
    _JOB_STATE[run_id] = st

def _cleanup_jobs():
    now = _now_epoch()
    dead = []
    for rid, st in _JOB_STATE.items():
        ended = int(st.get("ended_at", 0) or 0)
        if ended and (now - ended) > _JOB_TTL_SECONDS:
            dead.append(rid)
    for rid in dead:
        _JOB_STATE.pop(rid, None)

def _run_remind_job(run_id: str, subject: Optional[str], body: Optional[str], prepare: bool, respect_sentlog: bool):
    """
    Runs reminder enqueue + queue processing in background.
    This keeps HTTP fast and avoids proxy timeouts.
    """
    _job_set(run_id, status="running", started_at=_now_epoch(), ended_at=0, error="")
    try:
        info = enqueue_remaining_pending_emails(
            subject=subject,
            body=body,
            prepare=prepare,
            respect_sentlog=respect_sentlog,
        )

        # If you have quota-aware sending, process what can be sent now:
        # send_stats = process_deferred_email_queue()

        _job_set(
            run_id,
            status="completed",
            ended_at=_now_epoch(),
            info=info or {},
            send_stats=info or {},
        )
    except Exception as e:
        _job_set(run_id, status="failed", ended_at=_now_epoch(), error=str(e))
        # try:
        #     bridge_log("manual_remind_failed", level="error", run_id=run_id, error=str(e))
        # except Exception:
        #     pass
    finally:
        # best-effort cleanup
        try:
            gc.collect()
        except Exception:
            pass

# --- Revoke / reset endpoint --------------------------------------------------
@app.post("/revoke")
@app.get("/revoke")
def revoke_token():
    """
    Revoke the stored OAuth credentials (if any) **and** delete the local pickle.
    Works even after a restart when creds is None because it reloads the file.
    Always returns JSON {"status": "cleared"} so you can blindly call it.
    """
    global creds

    # 1. Load creds from disk if not in memory
    if creds is None:
        for path in (SECRET_TOKEN_FILE, FALLBACK_TOKEN_FILE):
            if os.path.exists(path):
                try:
                    with open(path, "rb") as f:
                        creds = pickle.load(f)
                    break
                except Exception as e:
                    log.warning(f"Could not load creds from {path}: {e}")

    # 2. Choose a token to revoke (prefer refresh_token → longer‑lived)
    token_to_revoke = None
    if creds:
        token_to_revoke = getattr(creds, "refresh_token", None) or getattr(creds, "token", None)

    if token_to_revoke:
        try:
            resp = requests.post(
                "https://oauth2.googleapis.com/revoke",
                params={"token": token_to_revoke},
                headers={"content-type": "application/x-www-form-urlencoded"},
                timeout=10,
            )
            if resp.status_code != 200:
                log.warning(f"Google revoke returned {resp.status_code}: {resp.text}")
        except Exception as e:
            log.warning(f"Token revoke request failed: {e}")

    # 3. Delete local token cache (try both secret and fallback; secret may be read-only so ignore failures)
    for path in (SECRET_TOKEN_FILE, FALLBACK_TOKEN_FILE):
        try:
            if os.path.exists(path):
                os.remove(path)
        except Exception as e:
            log.warning(f"Failed to delete token file at {path}: {e}")

    creds = None
    bridge_log("oauth_revoked")
    return {"status": "cleared"}

def scheduled_enqueue_job():
    if not creds:
        return
    if isCreditsExpired:
        log.warning("Credits Expired. Skipping scheduled enqueue job.")
        bridge_log("scheduled_enqueue_skipped", reason="credits_expired")
        return
    subject = MAIN_EMAIL_SUBJECT
    body = MAIN_EMAIL_BODY  # or any string you want
    prepare = True
    respect_sentlog = True

    enqueue_remaining_pending_emails(
        subject=subject,
        body=body,
        prepare=prepare,
        respect_sentlog=respect_sentlog,
    )
    check_for_scheduled_method_calls()

def schedule_sync_tab():
    if not creds:
        return
    if isCreditsExpired:
        log.warning("Credits Expired. Skipping scheduled sync job.")
        return
    tab = latest_thread_tab()
    try:
        ensure_and_sync_thread_tab(tab)
        seed_new_tab_from_main(tab)
    except Exception as e:
        log.warning(f"[scheduled_sync_tab] ensure_and_sync_thread_tab failed: {e}")
# ---------------- Scheduler ---------------- #

scheduler = BackgroundScheduler(timezone=TIME_ZONE)
# scheduler.add_job(poll_group_mail, 'interval', minutes=1, id='poll_mail')
# scheduler.add_job(track_email_threads, 'interval', minutes=5, id='track_email_threads')
#scheduler.add_job(schedule_sync_tab, 'interval', minutes=5, id='schedule_sync_tab')
scheduler.add_job(scheduled_enqueue_job, 'interval', minutes=2, id='scheduled_enqueue_job')
scheduler.add_job(poll_group_mail,'interval',hours=12, id='poll_mail')
scheduler.add_job(schedule_sync_tab,'interval',hours=6, id='schedule_sync_tab')
#scheduler.add_job(send_reminders, 'cron', hour='9,15', id='daily_reminder')  # 09:00 & 15:00 daily
# scheduler.start()
_scheduler_started = False

@app.on_event("startup")
def startup_event():
    global _scheduler_started
    log.info("Agent started")
    bridge_log("startup")
    # Start the Cosmitude Bridge long-running loop in a background thread
    try:
        if not globals().get("_go_thread_started", False):
            Thread(target=go, daemon=True).start()
            globals()["_go_thread_started"] = True
            log.info("go() background thread started")
    except Exception as e:
        log.error(f"Failed to start go() thread: {e}", exc_info=True)
    if not _scheduler_started:
        # scheduler.add_job(scheduled_enqueue_job, 'interval', minutes=2, id='scheduled_enqueue_job')
        # scheduler.add_job(poll_group_mail,'cron',hour=0, id='poll_mail')
        scheduler.start()
        _scheduler_started = True
    try:
        if not creds:
            return
        # check_and_start_thread_if_missing()
    except Exception as e:
        log.warning(f"[startup] check_and_start_thread_if_missing failed: {e}")
#------------------------------------------
#Login
#------------------------------------------

def login():
    try:
        global Sessionid
        global username
        global MobileNumber
        global forumID
        tempJson = {
        "MACAddress": 'Bridge-Web',
        "UserName":"${userName}",
        "Password":"${Password}",
        "ServerID":"${CAServerID}",
        }
        headers = {'Content-Type': 'application/json'}
        variab =json.dumps(tempJson)
        response = requests.post("${CAServerIP}" + 'loginForDevice', data=variab,headers=headers, timeout=600)
        strData = str(response.text)
        respJson = json.loads(strData)
        Sessionid = respJson['ErrorMessage']['SessionID']
        countryCode = MobileNumber = respJson['ErrorMessage']['CountryCode']
        MobileNumber = countryCode+respJson['ErrorMessage']['MobileNumber']
        bridge_log("agent_started")
        getForumDetails()
    except Exception as e:
        print (e)
        return e

#------------------------------------------
#Forum Details
#------------------------------------------
def getForumDetails():
    try:
        tempJson = {
        "MACAddress": 'Bridge-Web',
        "ForumID":forumID,
        "SessionID":Sessionid,
        "ServerID":'${CAServerID}',
        }
        headers = {'Content-Type': 'application/json'}
        variab =json.dumps(tempJson)
        response = requests.post('${CAServerIP}' + 'getRequestedForumDetails', data=variab,headers=headers, timeout=600)
        if response.status_code == 200:
            responseStr = str(response.text)
            respJson = json.loads(responseStr)
            errorCode = respJson['ErrorCode']
            if errorCode == 1172:
                errorMsg = respJson['ErrorMessage']
                forumDetails = errorMsg['ForumDataArray']
                for singleForum in forumDetails:
                    singleForumDetails = singleForum[forumID]
                    saveForumDetails = singleForumDetails['NewForumJsonData']
                    with open('Ca email tracking_${TemplateName}_Admin.txt', 'w') as f:
                        json.dump(saveForumDetails, f)

    except Exception as e:
        print (e)
        return e

#------------------------------------------
#Client Sync
#------------------------------------------
def clienntSync():
    try:
        clientSyncJson = {
        "SessionID":Sessionid,
        "MACAddress":'Bridge-Web',
        "ServerID":"${CAServerID}",
        "ServerName":'Bridge'
        }
        headers = {'Content-Type': 'application/json'}
        variab =json.dumps(clientSyncJson)
        response = requests.post('${CAServerIP}' + 'syncUserData', data=variab,headers=headers, timeout=600)
        strData = str(response.text)
        dataRead = json.loads(strData)
        print(dataRead['ErrorMessage'])
        syncData = dataRead['ErrorMessage']['Admin']
        if syncData.count:
            for data in syncData:
                if 'Bridge' in data:
                    bridgeData = data['Bridge']
                    flowName = bridgeData ['FlowID']
                    mNumber = bridgeData ['MobileNumber']
                    #<YOUR CODE STARTS HERE>
                    if flowName == "${TemplateName}_Trigger" and MobileNumber != mNumber:
                        bridge_log("flow_trigger", flow=flowName, mobile=mNumber)

                elif 'UpdatedTemplateJson' in data:
                    templateForAdmin = data['UpdatedTemplateJson']
                    forumIDCheck = templateForAdmin['ForumID']
                    if forumIDCheck == forumID:
                        with open('Ca email tracking_${TemplateName}_Admin.txt', 'w') as f:
                            json.dump(templateForAdmin, f)
                        bridge_log("forum_details_cached")
    except Exception as e:
        print (e)

#------------------------------------------
#Send Bridge
#------------------------------------------
def sendBridge(bridgeData, replyFlow, replyData):
    try:
        global isCreditsExpired
        TemplateID = "${TemplateId}"
        ForumID = "${forumID}"
#        current_dir_path = os.getcwd()
#        filePath = open(os.path.join(current_dir_path, 'Ca email tracking_${TemplateName}_Admin.txt'), 'r')
#        content = filePath.read()
#        jsonData = json.loads(content)
        FID = "${FID}"
        tempJson ={
        "ForumID": ForumID,
        "SessionID": Sessionid,
        "MACAddress": 'Bridge-Web',
        "Time": "6516516156161",
        "ScheduledDateTime": "now",
        "ScheduledBoolean": 0,
        "FlowID": replyFlow,
        "EnableChat": 1,
        "FlowType": "Custom",
        "BridgeForward": 0,
        "TemplateID": TemplateID,
        "TextCount": 1,
        "ImageCount": 1,
        "InvoiceID": "",
        "DocumentCount": 0,
        "User": True,
        "VideoCount": 0,
        "ReplyBridgeID": "",
        "HiddenFlow": False,
        "TempBridgeId": str(uuid.uuid4()),
        replyFlow: replyData,
        "FID": FID,
        "ServerID":"${CAServerID}",
        "SentTo":'0'
        }
        variab = {"Data":json.dumps(tempJson)}
        up = {}
        response = requests.post('${CAServerIP}' + 'bridgeSendingToForum', files=up, data=variab, timeout=600)
        data = response.json()
        if isCreditsExpired and data.get("ErrorCode") != 3112:
            isCreditsExpired = False
        if data.get("ErrorCode") == 3112 or data.get("ErrorCode") == 1130:
            isCreditsExpired = True
    except Exception as e:
        print (e)
        return e
    
#--------------------------------------------------
# Send Blocked Domain Bridge
#--------------------------------------------------
def sendDominBlockedBridge(replyFlow, replyData):
    try:
        global isCreditsExpired
        TemplateID = "${TemplateId}"
        ForumID = "${forumID}"
#        current_dir_path = os.getcwd()
#        filePath = open(os.path.join(current_dir_path, 'Ca email tracking_${TemplateName}_Admin.txt'), 'r')
#        content = filePath.read()
#        jsonData = json.loads(content)
        FID = "${bFID}"
        tempJson = {
        "ForumID": ForumID,
        "SessionID": Sessionid,
        "MACAddress": 'Bridge-Web',
        "Time": "6516516156161",
        "ScheduledDateTime": "now",
        "ScheduledBoolean": 0,
        "FlowID": replyFlow,
        "EnableChat": 1,
        "FlowType": "Custom",
        "BridgeForward": 0,
        "TemplateID": TemplateID,
        "TextCount": 1,
        "ImageCount": 1,
        "InvoiceID": "",
        "DocumentCount": 0,
        "User": False,
        "VideoCount": 0,
        "ReplyBridgeID": "",
        "HiddenFlow": False,
        "TempBridgeId": str(uuid.uuid4()),
        replyFlow: replyData,
        "FID": FID,
        "ServerID":"${CAServerID}",
        "SentTo":'0'
        }
        variab = {"Data":json.dumps(tempJson)}
        up = {}
        response = requests.post('${CAServerIP}' + 'bridgeSendingToForum', files=up, data=variab, timeout=600)
        data = response.json()
        if isCreditsExpired and data.get("ErrorCode") != 3112:
            isCreditsExpired = False
        if data.get("ErrorCode") == 3112 or data.get("ErrorCode") == 1130:
            isCreditsExpired = True
    except Exception as e:
        print (e)
        return e

def fetchBlockedDomainData():
    # def generateReport(bridgeData, FID):
    try:
        forumID = "${forumID}"
        TemplateID = "${TemplateId}"
        fID = "${bFID}"
        currentTime = int(round(time.time()))
        reportName = "${TemplateName}_Report_BlockedDomains_Admin_" + fID
        currentTime = int(round(time.time()))
        tempJson = {
            "SessionID": Sessionid,
            "MACAddress": 'Bridge-Web',
            "ReportName": reportName,
            "User": False,
            "ReportSchedule": "now",
            "ForumID": forumID,
            "Label": "",
            "Operator": "",
            "Input": "",
            "StartDate": "",
            "EndDate": "",
            "TimePeriod": "",
            "TimePeriodInput": "",
            "TempBridgeId": str(uuid.uuid4()),
            "Time": str(currentTime),
            "SendGroupReport": [],
            "SpecificReport": [],
            "TemplateID": TemplateID,
            "FID":fID,
            "UserMobileNumber":"All",
            "ServerID":"${CAServerID}",
        }
        formData = {"Data":json.dumps(tempJson)}
        response = requests.post('${CAServerIP}' + 'generateReport', files={}, data=formData, timeout=600)
        data =  response.json()
        if data.get('ErrorCode') == 1042:
            errorMessage = data.get('ErrorMessage')
            allResponse = errorMessage.get(reportName)
            if len(allResponse) > 0:
                current = allResponse[-1]
                encodeDomain = current.get(BLOCKED_DOMAIN_FEILD_KEY)
                decodedDomain = base64.b64decode(encodeDomain).decode("utf-8")
                latest_blocked_domain = json.loads(decodedDomain)
                return latest_blocked_domain
            else:
                return {}
    except Exception as e:
        print (e)
        return e
    
#---------------------------------------------------
# Send Email Daily Limit
#---------------------------------------------------
def sendDailyEmailLimitBridge(replyFlow, replyData):
    try:
        global isCreditsExpired
        TemplateID = "${TemplateId}"
        ForumID = "${forumID}"
        FID = "${limitFID}"
        tempJson = {
        "ForumID": ForumID,
        "SessionID": Sessionid,
        "MACAddress": 'Bridge-Web',
        "Time": "6516516156161",
        "ScheduledDateTime": "now",
        "ScheduledBoolean": 0,
        "FlowID": replyFlow,
        "EnableChat": 1,
        "FlowType": "Custom",
        "BridgeForward": 0,
        "TemplateID": TemplateID,
        "TextCount": 1,
        "ImageCount": 1,
        "InvoiceID": "",
        "DocumentCount": 0,
        "User": False,
        "VideoCount": 0,
        "ReplyBridgeID": "",
        "HiddenFlow": False,
        "TempBridgeId": str(uuid.uuid4()),
        replyFlow: replyData,
        "FID": FID,
        "ServerID":"${CAServerID}",
        "SentTo":'0'
        }
        variab = {"Data":json.dumps(tempJson)}
        up = {}
        response = requests.post('${CAServerIP}' + 'bridgeSendingToForum', files=up, data=variab, timeout=600)
        data = response.json()
        if isCreditsExpired and data.get("ErrorCode") != 3112:
            isCreditsExpired = False
        if data.get("ErrorCode") == 3112 or data.get("ErrorCode") == 1130:
            isCreditsExpired = True
    except Exception as e:
        print(e)

def fetchDailyEmailLimitData():
    try:
        forumID = "${forumID}"
        TemplateID = "${TemplateId}"
        fID = "${limitFID}"
        currentTime = int(round(time.time()))
        reportName = "${TemplateName}_Report_AddLimits_Admin_" + fID
        tempJson = {
            "SessionID": Sessionid,
            "MACAddress": 'Bridge-Web',
            "ReportName": reportName,
            "User": False,
            "ReportSchedule": "now",
            "ForumID": forumID,
            "Label": "",
            "Operator": "",
            "Input": "",
            "StartDate": "",
            "EndDate": "",
            "TimePeriod": "",
            "TimePeriodInput": "",
            "TempBridgeId": str(uuid.uuid4()),
            "Time": str(currentTime),
            "SendGroupReport": [],
            "SpecificReport": [],
            "TemplateID": TemplateID,
            "FID":fID,
            "UserMobileNumber":"All",
            "ServerID":"${CAServerID}",
        }
        formData = {"Data":json.dumps(tempJson)}
        response = requests.post('${CAServerIP}' + 'generateReport', files={}, data=formData, timeout=600)
        data =  response.json()
        if data.get('ErrorCode') == 1042:
            errorMessage = data.get('ErrorMessage')
            allResponse = errorMessage.get(reportName)
            if len(allResponse) > 0:
               for item in reversed(allResponse):
                encodedType = item.get(f"{DAILY_EMAIL_LIMIT_FEILD_KEY}_2")
                limitType = base64.b64decode(encodedType).decode("utf-8")
                if limitType == "Email Daily Limit":
                    encodedValue = item.get(f"{DAILY_EMAIL_LIMIT_FEILD_KEY}_4")
                    limitValue = int(base64.b64decode(encodedValue).decode("utf-8"))
                    if limitValue > 0:
                        return {"email_daily_limit" : limitValue}
    except Exception as e:
        print(e)

# ---------------- Run via uvicorn ---------------- #
if __name__ == "__main__":
    import uvicorn
    import os
    from threading import Thread

    host = os.getenv("HOST", "0.0.0.0")
    port = int(os.getenv("PORT", os.getenv("UVICORN_PORT", "8000")))

    # Start go() thread (if you need it)
    try:
        if not globals().get("_go_thread_started", False):
            Thread(target=go, daemon=True).start()
            globals()["_go_thread_started"] = True
    except Exception as e:
        log.error(f"Failed to start go() thread in __main__: {e}", exc_info=True)

    # ✅ Works even if the file is renamed during deployment
    uvicorn.run(app, host=host, port=port)
    `}
`;